import BUILDING_INSPECTION from './buildingInspection';
import ENERGY_LABEL_LEADS from './energyLabelLeads';

const ENGLISH = {
  type: 'en-US',
  languageNames: {
    en: 'English',
    no: 'Norwegian',
    nb: 'Norwegian',
    de: 'German',
    fr: 'French',
    sv: 'Swedish',
    se: 'Swedish',
    da: 'Danish',
    it: 'Italian',
    fi: 'Finnish',
  },
  global: {
    noDataAvailable: 'No data available',
    move: 'Move',
    rotate: 'Rotate',
    model: 'Model',
    data: 'Data',
    all: 'All',
    controls: 'Controls',
    lastUpdated: 'Last updated',
    custom: 'Custom',
    name: 'Name',
    setpoints: 'Setpoints',
    email: 'Email',
    date: 'Date',
    timestamp: 'Timestamp',
    address: 'Address',
    street: 'Street',
    postcode: 'Postcode',
    city: 'City',
    country: 'Country',
    timezone: 'Timezone',
    language: 'Language',
    from: 'From',
    until: 'Until',
    selectStartDate: 'Select start date',
    selectEndDate: 'select end date',
    copied: 'Copied',
    average: 'Average',
    min: 'Min',
    max: 'Max',
    last: 'Last',
    new: 'New',
    type: 'Type',
    role: 'Role',
    category: 'Category',
    description: 'Description',
    status: 'Status',
    public: 'Public',
    active: 'Active',
    inactive: 'Inactive',
    hidden: 'Hidden',
    visible: 'Visible',
    show: 'Show',
    hide: 'Hide',
    enabled: 'Enabled',
    disabled: 'Disabled',
    actionRequired: 'Action Required',
    success: 'Success',
    none: 'None',
    error: 'Error',
    basicInfo: 'Basic Information',
    information: 'Information',
    display: 'Display',
    save: 'Save',
    saving: 'Saving…',
    saveSuccess: 'Saved',
    saveError: 'Failed to save',
    search: 'Search',
    close: 'Close',
    confirm: 'Confirm',
    yes: 'Yes',
    no: 'No',
    rename: 'Rename',
    editName: 'Edit name',
    download: 'Download',
    cancel: 'Cancel',
    update: 'Update',
    updating: 'Updating...',
    undo: 'Undo',
    done: 'Done',
    delete: 'Delete',
    discard: 'Discard',
    open: 'Open',
    password: 'Password',
    login: 'Login',
    loginWithAzure: 'Login with Azure',
    invalidCredentials: 'Invalid credentials',
    loginTooManyAttempts: 'Too many login attempts, try again in a few minutes',
    loginInactiveUser: 'This user account is no longer active',
    loginUnavailable: 'Could not log in right now, try again later',
    welcome: 'Welcome to Sastech',
    loginSubtitle: 'Sign in to access your dashboard',
    or: 'or',
    noData: 'No Data',
    key: 'Key',
    fetch: 'Fetch',
    add: 'Add',
    back: 'Back',
    apply: 'Apply',
    inDevelopment: 'In Development',
    notAuthorized: 'Not Authorized',
    heating: 'Heating',
    cooling: 'Cooling',
    ventilation: 'Ventilation',
    climate: 'Climate',
    battery: 'Battery',
    batteries: 'Batteries',
    capabilities: 'Capabilities',
    moveTo: 'Move to',
    building: 'Building',
    buildings: 'Buildings',
    floor: 'Floor',
    floors: 'Floors',
    sensors: 'Sensors',
    sensor: 'Sensor',
    controller: 'Controller',
    energySource: 'Energy source',
    session: 'Session',
    addDevice: 'Add Device',
    device: 'Device',
    devices: 'Devices',
    selectDevice: 'Select a device',
    edit: 'Edit',
    serialNumber: 'Serial Number',
    trash: 'Garbage',
    actions: 'Actions',
    restore: 'Restore',
    emptyTrash: 'Empty Garbage',
    selectCategory: 'Select...',
    create: 'Create',
    monthChartText: [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ],
    weekdaysShort: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
    weekdays: [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
    ],
    today: 'Today',
    title: 'Title',
    to: 'to',
    remove: 'Remove',
    inspect: 'Inspect',
    compare: 'Compare',
    export: 'Export',
    total: 'Total',
    activate: 'Activate',
    color: 'Color',
    text: 'Text',
    link: 'Link',
    frame: 'Frame',
    info: 'Info',
    saveChanges: 'Save Changes',
    sidebarMenu: 'Sidebar Menu',
    icons: 'Icons',
    ok: 'OK',
    exit: 'Exit',
    exportImage: 'Export Image',
    exportSelected: 'Export Selected',
    directions: {
      top: 'Top',
      bottom: 'Bottom',
      right: 'Right',
      left: 'Left',
      front: 'Front',
      back: 'Back',
      isometric: 'Isometric',
    },
    switchVendor: 'Switch vendor',
    searchVendors: 'Search vendors...',
    noVendorsFound: 'No vendors found',
    onlyFjordkraft: 'Only Fjordkraft',
  },
  chart: {
    zoomIn: 'Zoom in',
    zoomOut: 'Zoom out',
    rotate: 'Rotate',
    fullscreen: 'Fullscreen',
    rotateTip: 'Click and drag to rotate chart',
  },
  data: {
    loading: 'Loading...',
    loadingData: 'Loading data...',
    noResults: 'No results found.',
    error: 'Error',
    failedToLoadData: 'Failed to load data',
    noDataAvailable: 'No data available',
  },
  general: {
    temperature: 'Temperature',
    co2: 'CO₂',
    humidity: 'Humidity',
    zone: 'Zone',
    data: 'Data',
    edit: 'Edit',
    analyze: 'Analyze',
    chartType: 'Chart Type',
    toggleSeries: 'Toggle Series',
    resetFilters: 'Reset Filters',
    exportData: 'Export Data',
  },
  chat: {
    title: 'Sastech Chat',
    placeholder: 'Type your message here…',
    send: 'Send',
    unknownUser: 'Unknown User',
  },
  navigation: {
    dashboard: 'Dashboard',
    eosDashboard: 'Overview',
    devices: 'Devices',
    map: 'Map',
    buildings: 'Buildings',
    reports: 'Reports',
    settings: 'Settings',
    logout: 'Log out',
    sastech: 'Sastech Settings',
    analytics: 'Analytics',
    buildings3D: 'Buildings3D',
    superSettings: 'Sastech',
    buildingInspection: 'Inspection',
    expandSidebar: 'Expand sidebar',
    collapseSidebar: 'Collapse sidebar',
    userCalendar: 'User Calendar',
    energyLabelLeads: 'Energy Label Leads',
  },
  reports: {
    title: 'Reports',
    orderReport: 'Order report',
    orderDescription: 'The report shows up in the list when it is ready.',
    reportType: 'Report type',
    kinds: {
      eos_weekly: 'Weekly energy report',
      eos_monthly: 'Monthly energy report',
    },
    period: 'Period',
    week: 'Week {week}',
    reportLanguage: 'Report language',
    submit: 'Order',
    submitting: 'Ordering…',
    status: {
      queued: 'Queued',
      generating: 'Generating',
      completed: 'Ready',
      failed: 'Failed',
    },
    exportExcel: 'Download Excel',
    exportPdf: 'Download PDF',
    makePdf: 'Make PDF',
    pdfPending: 'PDF is being generated…',
    confirmDeleteTitle: 'Delete report',
    confirmDeleteMessage:
      'The report is removed from the list. This cannot be undone.',
    noReports: 'No reports yet. Order the first one.',
    noSearchHits: 'No reports match the search.',
    noMeters: 'The building has no active energy meters.',
    duplicateOrder: 'The same report is already being generated.',
    orderError: 'Could not order the report',
    orderSuccess: 'The report is ordered and being generated.',
    deleteError: 'Could not delete the report',
    pdfError: 'Could not order the PDF',
    pdfRequested: 'The PDF is ordered and being generated.',
    requestedBy: 'Ordered by',
    ordered: 'Ordered',
    daysAgo: '{count} days ago',
    sheets: {
      summary: 'Summary',
      days: 'Per day',
      hours: 'Per hour',
      sources: 'Meters',
      profile: 'Daily profile',
    },
    excel: {
      parameter: 'Parameter',
      value: 'Value',
      unit: 'Unit',
      delivered: 'Delivered energy',
      production: 'Own production',
      export: 'Exported',
      net: 'Used in the building',
      baseline: 'Baseline',
      previousYear: 'Previous year',
      co2: 'CO2',
      baselineCo2: 'CO2 baseline',
      hoursWithData: 'Hours with data',
      meanKW: 'Mean load',
      maxKW: 'Highest hour',
      maxAt: 'Highest hour at',
      baseLoadKW: 'Base load',
      nightKW: 'Night load 00–05',
      peakHours: 'Hours at or above 90 % of max',
      weekday: 'Weekday',
      time: 'Hour',
      source: 'Meter',
      missingHours: 'Missing hours',
      energy: 'Energy',
      co2Factor: 'CO2 factor',
      role_delivered: 'delivered energy',
      role_production: 'own production',
      role_export: 'export',
      role_excluded: 'not counted',
    },
  },
  map: {
    addBuildingAtCenter: 'Add building at center',
  },
  pagination: {
    rowsPerPage: 'Rows per page',
    rangeSeparator: 'of',
  },
  devices: {
    title: 'Device Overview',
    reset: 'Reset',
    noDevices: 'No devices found.',
    unnamed: 'Unnamed device',
    copySensorTag: 'Copy sensor tag',
    graph: {
      inspect: 'Inspect',
      edit: 'Edit',
      chartType: 'Chart Type',
      toggleSeries: 'Toggle Series',
      resetFilters: 'Reset Filters',
      exportData: 'Export Data',
      noData: 'No data',
      bar: 'Bar',
      line: 'Line',
      pie: 'Pie',
      scatter: 'Scatter',
      radar: 'Radar',
    },
    categoryFilter: {
      filter: 'Filter',
      filterByCategory: 'Filter by Category',
      selectAll: 'Select All',
      clearAll: 'Clear All',
      searchCategories: 'Search categories...',
      noCategories: 'No categories found',
      noData: 'No data',
      devices: 'devices',
      selected: 'Selected',
      category: 'category',
      categories: 'categories',
      more: 'more',
    },
    detailLevel: {
      label: 'Detail level',
      units: {
        minutes: 'Minutes',
        minutesShort: 'min',
        day: 'Day',
      },
    },
    dateRange: {
      startLabel: 'Start Date',
      endLabel: 'End Date',
    },
    eosConsumption: {
      card: {
        dateLabel: 'Date',
        total: {
          production: 'Total Production:',
          consumption: 'Total Consumption:',
        },
        highestPeak: 'Highest Peak:',
        calculatedPrice: {
          eur: 'Calculated Price (EUR):',
          nok: 'Calculated Price (NOK):',
        },
      },
    },
  },

  analytics: {
    session: {
      moreActions: 'More actions',
      newSession: 'New session',
      unsaved: 'Unsaved changes',
      namePlaceholder: 'Session name',
      deleteTitle: 'Delete session?',
      deleteDescription:
        'This permanently removes the saved session and its device selection.',
      noSessions: 'No saved sessions',
      discardTitle: 'Discard unsaved changes?',
      discardDescription:
        'The current session has changes that have not been saved. Switching will lose them.',
    },
    notifications: {
      overlayMissingZone:
        'Building has no zone configured. Using default (NO1).',
      overlayMissingRate: 'Failed to fetch exchange rate',
      overlayFetchFailed: 'Error fetching overlay data',
      sessionSaved: 'Session saved',
      sessionCreated: 'Session created',
      sessionDeleted: 'Session deleted',
      sessionSaveFailed: 'Could not save the session',
      sessionDeleteFailed: 'Could not delete the session',
      sessionsLoadFailed: 'Could not load saved sessions',
      devicesLoadFailed: 'Could not load devices',
      buildingsLoadFailed: 'Could not load buildings',
      readingsLoadFailed: 'Could not load readings for one or more devices',
      nameRequired: 'Give the session a name before saving',
      rangeTooWide:
        'Ranges over 7 days are slow at this sampling interval. Switch to Daily for better performance.',
    },
    title: 'Real-time Analytics & KPIs',
    pageTitle: 'Analytics',
    searchPlaceholder: 'Search devices…',
    buttons: {
      toggleSidebar: 'Toggle device list',
      showAll: 'Show all',
      hideAll: 'Hide all',
      showTrends: 'Show trends',
      hideTrends: 'Hide trends',
      clearAll: 'Clear all',
      export: 'Export',
    },
    exportMenu: {
      exportAsPNG: 'Export as PNG',
      exportAsCSV: 'Export as CSV',
    },
    thresholds: {
      max: 'Max:',
      min: 'Min:',
      aboveThreshold: 'Above Threshold',
      belowThreshold: 'Below Threshold',
    },
    timeAxis: {
      label: 'Time axis',
      actual: 'Actual time',
      timeOfDay: 'Time of day',
      dayOfWeek: 'Day of week',
      dayOfMonth: 'Day of month',
      bucket: 'Group by',
    },
    legend: {
      manage: 'Manage',
      overlays: 'Overlays',
      series: 'Series',
      trends: 'Trends',
      more: 'more',
    },
    overlay: {
      weatherAndElectricity: 'Weather & Electricity',
      none: 'None',
      outsideTemperature: 'Outside Temperature',
      elecPrice: 'Elec. Price',
      elecPriceFull: 'Elec. Price (kr/kWh)',
      loadingData: 'Loading data...',
    },
    collab: {
      viewingSession: 'viewing this session',
      updatedSession: 'updated this session',
      deletedSession: 'deleted this session',
      conflictTitle: 'Someone saved a newer version',
      conflictDescription:
        'This session was saved by someone else while you were editing. Load their version (your edits are lost) or overwrite it with yours.',
      loadTheirs: 'Load their version',
      overwrite: 'Overwrite',
    },
    picker: {
      wholeBuilding: 'Whole building',
      noClimateSources: 'No buildings with zones',
      noAveragesData: 'No climate data yet',
      noIndoorSensors: 'Building has no indoor sensors',
      inSession: 'In session',
      searchBuildings: 'Search buildings…',
      noBuildingsMatch: 'No buildings match',
      noWeatherData: 'No weather data yet',
    },
    devices: {
      noDevicesMatch: 'No devices match',
      unnamedDevice: 'Unnamed Device',
      noDevicesSelected: 'No devices selected',
      devicesFound: 'devices found',
      noDevicesMatchSearch: 'No devices match your search',
      deviceSelected: 'device selected',
      devicesSelected: 'devices selected',
      shown: 'shown',
      total: 'total',
    },
    chart: {
      zoomHint: 'Zoomed (double-click to reset)',
      loadingChartData: 'Loading chart data...',
      addDevicesToVisualize: 'Add devices to visualize data',
    },
    liveEvents: {
      title: 'Live Events',
      events: 'events',
      waitingForEvents: 'Waiting for events…',
    },
    modal: {
      weatherIntervalHint: 'Weather data has hourly resolution',
      deviceSettings: 'Device Settings',
      addDevices: 'Add Devices',
      clear: 'Clear',
      startTime: 'Start Time',
      endTime: 'End Time',
      samplingInterval: 'Sampling Interval',
      dataAggregationGranularity: 'Data aggregation granularity',
      startMustBeBeforeEnd: 'Start must be before end',
      intervals: {
        fiveMinutes: '5 minutes',
        fifteenMinutes: '15 minutes',
        oneHour: '1 hour',
        daily: 'Daily',
      },
    },
    connectionStatus: {
      error: 'ERROR',
      connected: 'CONNECTED',
      connecting: 'CONNECTING',
      disconnected: 'DISCONNECTED',
    },
  },

  confirmButton: {
    continue: 'Continue',
  },

  eosDashboard: {
    headerTitle: 'Energy Overview',
    energyKnowledge: {
      title: 'Energy analysis',
      lastMonth: 'Last month',
    },
    building: 'Building',
    selectBuilding: 'Select Building',
    outdoorTemperature: 'Outdoor Temperature',
    noData: 'N/A',
    electricityPrice: 'Electricity Price',
    electricityPrices: 'Electricity Prices',
    noPriceData: 'No price data available.',
    electricityConsumption: 'Electricity Consumption',
    baseline: 'Baseline',
    viewLabel: 'View:',
    aggregated: 'Aggregated',
    meteringPoint: 'Metering Point:',
    individualTitle: 'Individual Metering Points',
    eosSourcesTitle: 'Individual EOS Devices',
    footprint: 'CO₂ Footprint(Reduction)',
    co2Footprint: 'CO₂ Footprint',
    totalco2Footprint: 'Total CO₂ Footprint',
    consumption: 'Consumption',
    avgMaxKwp: 'Average max kWp',
    higher: 'Higher',
    lower: 'Lower',
    normal: 'Normal',
    priceWord: 'Price',
    vsAverage: 'Vs Average',
    baselineChart: {
      total: 'Total',
      average: 'Average',
      leftAxis: 'kWh (Consumption)',
      rightAxis: 'kWp (Avg Max)',
      co2Avg: 'CO₂ Avg',
      missingData: 'Missing data',
      missingDataDescription: 'Values are missing for this month',
    },
    energyLabel: {
      title: 'Dynamic Energy Label',
      withoutSastech: 'Official Label',
      withSastech: 'Dynamic Label',
      deliveredEnergy: 'Calculated delivered energy',
      insufficientData:
        'Only {months} months of data available. The label may not be representative.',
      noFloorArea: 'Net usable floor area is not set for this building.',
      noBuildingCategory: 'Building category is not set for this building.',
      fossilFuelShare: 'Share of electricity/oil/gas',
      reduction: 'Reduction',
      floorArea: 'Floor area',
      annualConsumption: 'Annual',
      energyGrade: 'Energy Grade',
      labels: {
        A: 'Very energy efficient',
        B: 'Energy efficient',
        C: 'Moderate efficiency',
        D: 'Below average',
        E: 'Poor efficiency',
        F: 'Very poor efficiency',
        G: 'Least efficient',
      },
    },
    kpiSection: {
      trend: {
        aboveAverage: 'Above',
        belowAverage: 'Below',
        atAverage: 'At',
        averageThisPeriod: 'average this period',
      },
      consumption: {
        title: 'Total Consumption',
        subtitle: {
          increased: 'Increased by {delta} {unit}',
          reduced: 'Reduced by {delta} {unit}',
          noChange: 'No change in consumption',
          noBaseline: 'No baseline data available',
        },
        detail: 'Energy consumption last {periodLabel}',
      },
      co2: {
        title: 'Total CO₂ Footprint',
        subtitle: {
          reduced: 'Reduced {delta} {unit}',
          increased: 'Increased {delta} {unit}',
          noChange: 'No change in emissions',
          noBaseline: 'No baseline data available',
        },
        detail: 'Carbon footprint last {periodLabel}',
      },
      adjustedConsumption: {
        title: 'Degree-Day Adjusted Consumption',
      },
      estate: {
        title: 'Buildings & Sources',
        value: '{count} Buildings',
        subtitle: '{count} Total sources',
        detail: 'Currently {count} active devices',
      },
      price: {
        title: 'Current Price',
        detail: 'Electricity price right now',
      },
      temperature: {
        title: 'Temperature',
        value: '{value}{unit}',
        chipDelta: '{signedDelta}{unit}',
        subtitleText: '{text}',
        detail: 'Current weather conditions',
      },
    },
    savingsSection: {
      consumptionComparison: {
        title: 'Consumption Comparison - last year vs year to date',
        baseLineLabel: 'Baseline',
        peakHourlyLabel: 'Highest Peak',
      },
      consumptionSavings: {
        title: `Consumption Savings - baseline vs. {{currentYear}}`,
      },
    },
    electricityChart: {
      totalLabel: 'Total',
      totalEnergyConsumption: 'Total Energy Consumption',
      totalElectricityConsumption: 'Total Electricity Consumption',
      energyConsumption: 'Energy Consumption',
      electricityConsumption: 'Electricity Consumption',
      noDataForSelectedPeriod: 'No data for selected time period',
      meteringPointTitle: 'Metering Point: {id}',
      sourceTitle: 'Source: {id}',
      unknownLabel: 'Unknown',
      unknownIdLabel: 'Unknown ID',
      powerFactorLabel: 'Power Factor Cos φ',
      powerFactorWarning: 'Power factor below 0.95 may incur tariff penalties',
      renameDialog: {
        title: 'Rename Metering Point',
        label: 'Display Name',
        helpTextPrefix: 'Original Metering Point ID',
      },
      errors: {
        loadAggregatedData: 'Failed to load aggregated data',
        loadFilteredData: 'Failed to load filtered data',
        fetchDisplayName: 'Failed to fetch display name information',
        invalidDisplayName: 'Please provide a valid display name',
        renameFailed: 'Failed to rename eos device',
        renameUnknown: 'An error occurred while renaming the eos device',
        noDataToExport: 'No data available to export',
        exportFailedTitle: 'Export Failed',
        exportFailedPrefix: 'Failed to export data',
        unknownError: 'Unknown error',
        enterValidDisplayName: 'Please enter a valid display name',
        validationErrorTitle: 'Validation Error',
      },
      tooltip: {
        electricityElhub: 'Electricity',
        reactiveEnergy: 'Reactive Energy',
        buildingsLabel: 'Buildings',
        meteringPointsLabel: 'Metering Points',
        districtHeating: 'District Heating',
        solarPv: 'Produced Solar Power',
        exportedElectricity: 'Exported Electricity',
      },
    },
    co2BarChart: {
      baseline: 'Baseline',
      legendBaseline: 'Baseline',
      currentValues: 'Current Values',
      co2Emissions: 'CO₂ Emissions',
      dailyEmissions: 'Daily emissions',
      monthlyEmissions: 'Monthly emissions',
      months: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ],
      goal: 'Goal',
    },
    chartMenu: {
      rename: 'Rename',
      exportExcel: 'Export Excel',
      exportCSV: 'Export CSV',
    },
    periodOptions: {
      '3days': {
        label: 'Last 3 days',
        mobileLabel: '3 days',
        chartLabel: '3 days',
      },
      '30days': {
        label: 'Last 30 days',
        mobileLabel: '30 days',
        chartLabel: '30 days',
      },
      '3months': {
        label: 'Last 3 months',
        mobileLabel: '3 months',
        chartLabel: '3 months',
      },
    },
    chartSubtitle: {
      today: 'Total for today',
      oneDay: 'Total for 1 day',
      days: 'Total for {days} days',
      oneWeek: 'Total for 1 week',
      weekAndDays: 'Total for 1 week and {days} day(s)',
      weeks: 'Total for {weeks} weeks',
      weeksAndDays: 'Total for {weeks} weeks and {days} day(s)',
      months: 'Total for {months} months',
      monthsAndDays: 'Total for {months} months and {days} day(s)',
      monthsAndWeeks: 'Total for {months} months and {weeks} week(s)',
    },
    datePicker: {
      startLabel: 'Start',
      endLabel: 'End',
    },
    weatherTemperature: {
      noData: 'No weather data available',
      headerTitle: 'Weather Forecast',
      headerSubtitle: 'Forecast',
      tooltip: {
        conditions: 'Conditions',
        temperature: 'Temperature',
        wind: 'Wind',
        windDirection: 'Wind direction',
        pressure: 'Pressure',
        cloudCover: 'Cloud cover',
        fog: 'Fog',
        uvIndex: 'UV Index',
        precipitation: 'Precipitation next hour',
      },
      stats: {
        min: 'Min',
        avg: 'Avg',
        max: 'Max',
        current: 'Current',
      },
    },
    tempTrend: {
      stable: 'Stable outdoor temperature',
      graduallyRising: 'Gradually rising temperature',
      graduallyFalling: 'Gradually falling temperature',
      rising: 'Rising outdoor temperature',
      falling: 'Falling outdoor temperature',
    },
    noDataForPeriod: 'No energy data for the selected period',
    totalEnergy: 'Total energy',
    filters: {
      noMatch: 'No nodes match all selected categories',
    },
    staleData: {
      warningText: "yesterday's data is unavailable",
      showingDataFrom: 'Showing data from',
    },
    sankey: {
      noData: 'No sankey data available.',
      searchNodes: 'Search nodes...',
      selectedNodes: 'Selected Nodes',
      csvValue: 'Value (kWh)',
      csvDeviceId: 'Device ID',
    },
  },

  superSettings: {
    securityLog: {
      title: 'Security log',
      levelBadge: 'Level 10',
      intro:
        'Logins, changes, data access and API usage across all vendors. Logins, changes and data access are kept for 90 days, usage for 30 days.',
      error: 'The security log could not be loaded.',
      tabs: {
        overview: 'Overview',
        logins: 'Logins',
        changes: 'Changes',
        reads: 'Data access',
        usage: 'Usage',
        sessions: 'Sessions',
      },
      filters: {
        period: 'Period',
        last24h: 'Last 24 hours',
        last7d: 'Last 7 days',
        last30d: 'Last 30 days',
        last90d: 'Last 90 days',
        custom: 'Custom',
        vendor: 'Vendor',
        allVendors: 'All vendors',
        exportCsv: 'Export CSV',
        refresh: 'Refresh',
      },
      totals: {
        logins: 'Logins',
        loginsHint: '{users} users, {ips} IPs',
        reads: 'Data access',
        readsHint: '{users} users',
        readsTooltip: 'Reads of user lists, vendor lists, leads and logs',
        failedLogins: 'Failed logins',
        rateLimitedHint: '{count} blocked by the rate limit',
        changes: 'Changes',
        deletesHint: '{count} deletes',
        accessChanges: 'Access changes',
        accessHint: 'Levels, vendor access, Entra ID',
        requests: 'API requests',
        requestsHint: '{users} active users',
        compromised: 'Possibly compromised',
        compromisedHint: 'Accounts to check',
        unknownOutcome:
          '{count} logins from before outcomes were recorded are counted separately.',
        truncated:
          'This period is large; only the first 20 000 entries were checked.',
      },
      attention: {
        title: 'Needs attention',
        empty: 'Nothing needs attention in this period.',
        high: 'High',
        medium: 'Medium',
        low: 'Low',
        showMore: 'Show all {count}',
      },
      compromised: {
        title: 'Possibly compromised accounts',
        empty: 'No account shows signs of being compromised.',
        help: 'Usage no person could produce, or one session used from several places at once.',
      },
      chart: {
        title: 'Logins per day',
        success: 'Successful',
        failed: 'Failed',
        rateLimited: 'Rate-limited',
      },
      sensitive: {
        title: 'Recent access changes',
        empty: 'No access changes in this period.',
      },
      alerts: {
        failedLoginsThenSuccess:
          '{count} failed logins for {who}, then a successful login',
        failedLogins: '{count} failed logins for {who}',
        failedLoginsIp:
          '{count} failed logins from {ip}, against {accounts} accounts',
        rateLimited: '{count} blocked login attempts for {who}',
        newIp: '{who} logged in from a new IP address ({ip})',
        levelRaised: '{who} raised from level {old} to {new} by {by}',
        accessChange: 'Access changed for {who} ({fields}) by {by}',
        userDeleted: '{who} was deleted by {by}',
        massDelete: '{who} deleted {count} records within 10 minutes',
        requestBurst: '{who} made {count} requests in one minute',
        alwaysOn: '{who} was active {count} hours in one day',
        parallelLocations:
          '{who} was used from {count} IP addresses at the same time',
        parallelDevices: '{who} was used from {count} devices at the same time',
        robotRhythm:
          '{who} made requests at a machine-like steady pace for {count} minutes',
        changeBurst: '{who} made {count} changes within 10 minutes',
        vendorHopping: '{who} worked in {count} vendors within one hour',
        readBurst: '{who} read critical data {count} times within 10 minutes',
        unknown: 'Unknown alert',
        someone: 'unknown account',
        occurrences: '{count} times in this period',
      },
      alertNames: {
        failedLoginsThenSuccess: 'Login after many failures',
        failedLogins: 'Many failed logins',
        failedLoginsIp: 'Failing IP address',
        rateLimited: 'Rate-limited',
        newIp: 'New IP address',
        levelRaised: 'Level raised',
        accessChange: 'Access changed',
        userDeleted: 'User deleted',
        massDelete: 'Mass delete',
        requestBurst: 'Request burst',
        alwaysOn: 'Always on',
        parallelLocations: 'Several places at once',
        parallelDevices: 'Several devices at once',
        robotRhythm: 'Machine-like pace',
        changeBurst: 'Change burst',
        vendorHopping: 'Vendor hopping',
        readBurst: 'Bulk reading',
      },
      logins: {
        time: 'Time',
        outcome: 'Outcome',
        method: 'Method',
        account: 'Account',
        vendor: 'Vendor',
        ip: 'IP address',
        device: 'Device',
        allOutcomes: 'All outcomes',
        allFailures: 'All failures',
        allMethods: 'All methods',
        searchEmail: 'Search email',
        searchIp: 'IP address',
        filterByIp: 'Show logins from this IP',
        filterByAccount: 'Show logins for this account',
        empty: 'No logins match the filters.',
      },
      outcomes: {
        success: 'Success',
        wrong_password: 'Wrong password',
        unknown_user: 'Unknown user',
        inactive: 'Deactivated',
        invalid_input: 'Invalid input',
        rate_limited: 'Rate-limited',
        unknown_vendor: 'Unknown tenant',
        invalid_session: 'Invalid session',
        unknown: 'Not recorded',
      },
      methods: {
        password: 'Password',
        entra: 'Entra ID',
      },
      changes: {
        time: 'Time',
        action: 'Action',
        collection: 'Collection',
        record: 'Record',
        by: 'By',
        vendor: 'Vendor',
        endpoint: 'Request',
        history: 'History',
        allActions: 'All actions',
        create: 'Created',
        update: 'Updated',
        delete: 'Deleted',
        collectionPlaceholder: 'Collection, like users',
        fieldPlaceholder: 'Field, like level',
        empty: 'No changes match the filters.',
        filterByUser: 'Show changes by this user',
      },
      reads: {
        time: 'Time',
        user: 'User',
        area: 'What',
        vendor: 'Vendor',
        ip: 'IP address',
        device: 'Device',
        allAreas: 'All except the security log',
        everything: 'Everything, including the security log',
        searchIp: 'IP address',
        filterByUser: 'Show reads by this user',
        filterByIp: 'Show reads from this IP',
        empty: 'No reads match the filters.',
        note: 'Reads of user lists, vendor lists, leads and logs, kept for 90 days.',
      },
      readAreas: {
        vendors: 'Vendor list',
        users: 'User list',
        alarmUsers: 'Alarm users',
        energyLabelLeads: 'Energy label leads',
        enerskyAccess: 'Enersky access',
        feedback: 'Feedback',
        requestLogs: 'Request logs',
        securityLog: 'Security log',
        other: 'Other',
      },
      usage: {
        user: 'User',
        requests: 'Requests',
        peak: 'Peak per minute',
        activeMinutes: 'Active minutes',
        ips: 'IPs',
        devices: 'Devices',
        vendors: 'Vendors',
        flags: 'Flags',
        flaggedOnly: 'Only users with flags',
        compromisedBadge: 'Possibly compromised',
        empty: 'No API usage in this period.',
        note: 'API usage is kept for 30 days.',
      },
      sessions: {
        user: 'User',
        rights: 'Rights',
        method: 'Method',
        ip: 'IP address',
        device: 'Device',
        started: 'Logged in',
        lastSeen: 'Last seen',
        status: 'Status',
        open: 'Open',
        revoked: 'Revoked',
        expired: 'Expired',
        idle: 'Idle',
        level: 'Level {level}',
        tenants: '+{count} vendors',
        openOnly: 'Only open sessions',
        revoke: 'Revoke',
        revokeTitle: 'Revoke this session?',
        revokeText: 'The session of {who} ({method}, {ip}) is ended.',
        cancel: 'Cancel',
        revokeFailed: 'The session could not be revoked.',
        empty: 'No sessions match the filters.',
        note: 'A session ends {absolute} hours after login, or after {idle} hours without use. Sessions are kept for 90 days.',
        notEnforced:
          'Sessions are recorded but not enforced yet. Revoking marks a session as ended; it logs the user out once enforcement is turned on.',
      },
      history: {
        title: 'Record history',
        empty: 'No recorded changes for this record.',
        close: 'Close',
        open: 'Show the history of this record',
      },
    },
    areasMenu: {
      securityLog: 'Security log',
      createDashboard: 'Dashboard',
      feedback: 'Feedback',
      projects: 'Projects',
      icMeter: 'IC-Meter',
      lakeSensors: 'Lake Sensors',
      eosDevices: 'EOS Devices',
      deviceMapping: 'Device Mapping',
      energyLabeling: 'Energy Labeling',
      alarmSystems: 'Alarms',
      enerskyAccess: 'Enersky Access',
    },
    dataQuality: {
      title: 'Data Quality Inspector',
      subtitle: 'Live overview of all sensor lakes and device payload health.',
      noLakes: 'No sensor lakes found',
      noDevices: 'No devices',
      allReporting: 'All reporting',
      missing: 'missing',
      device: 'device',
      devices: 'devices',
      missingData: 'Missing data',
    },
    createDashboard: {
      header: 'New Client Dashboard',
      sections: {
        companyDetails: 'Company Details',
        address: 'Address',
        contactDetails: 'Contact Details',
      },
      fields: {
        companyName: 'Company Name',
        organizationNumber: 'Organization Number',
        phoneNumber: 'Phone Number',
        timezone: "Client's Local Timezone",
      },
      helperText: {
        organizationNumber: 'Business registration number',
        timezone: 'Select the client’s local timezone',
      },
      buttons: {
        cancel: 'Cancel',
        createClient: 'Create Client',
      },
    },
    sastechFeedback: {
      title: 'Sastech Feedback',
      table: {
        title: 'Feedback Messages',
        message: 'Message',
        actions: 'Actions',
        resolved: 'Resolved',
        unResolved: 'Unresolved',
        filter: 'Filter',
        customerFeedback: 'Customer Feedback',
        resolvedBy: 'by',
        comment: 'Comment',
        developerFeedback: 'Developer Feedback',
        assignDeveloper: 'Assign Developer',
        suggestedAction: 'Suggested Action',
        resolvedTickets: 'Resolved tickets',
        tags: 'Tags',
        noTagsProvided: 'No tags provided',
        vote: 'Vote',
        resolvedTicketsThisWeek: 'Resolved tickets this week',
        last7Days: 'Last 7 days',
        newTicketsThisWeek: 'New tickets this week',
        featureTicketsThisWeek: 'Feature tickets this week',
        bugTicketsThisWeek: 'Bug tickets this week',
      },
      buttons: {
        resolve: 'Resolve',
        save: 'Save Response',
      },
      confirm: {
        resolve: 'Are you sure you want to resolve this feedback?',
        delete: 'Are you sure you want to delete this feedback?',
      },
      details: {
        browserInfo: 'Browser Info:',
        device: 'Device',
        operatingSystem: 'Operating System',
        path: 'Path',
        resolution: 'Resolution',
        na: 'na',
        screenshotAlt: 'screenshot',
      },
    },
    alarmSystems: {
      titleEdit: 'Edit Alarm System',
      description:
        'Manage and create alarm systems with customized notifications and heartbeat monitoring to stay informed about critical events and ensure timely responses.',
      titleCreate: 'Create Alarm System',
      title: 'Alarms',
      accordion: {
        details: 'Alarm Details',
        heartbeat: 'Heartbeat Details',
        notification: 'Notification Details',
        connectedDevices: 'Connected Device Alarms',
      },
      fields: {
        systemName: 'Alarm System Name',
        location: 'Location',
      },
      heartbeat: {
        explanation:
          'The heartbeat interval is the time in seconds between each heartbeat signal sent by the alarm system to the server. This signal indicates that the system is active and functioning properly. If the server does not receive a heartbeat signal within a specified time frame, it may indicate a problem with the system.',
        monitor: 'Heartbeat Monitor',
        hours: 'Hours',
        minutes: 'Minutes',
        seconds: 'Seconds',
      },
      notification: {
        type: 'Notification Type',
        selectType: 'Select Notification Type',
        options: {
          sms: 'SMS',
        },
        recipient: 'Notification Recipient',
        recipients: 'Notification Recipients',
        selectUser: 'Select User',
        orAddManually: 'Or add e-mail or mobile number manually:',
        addRecipient: 'Add Recipient',
        contact: 'Email / mobile number',
        minimumSeverity: 'Minimum severity',
        severityLevels: {
          1: 'Info',
          2: 'Warning',
          3: 'Minor',
          4: 'Major',
          5: 'Critical',
        },
        errors: {
          empty: 'Recipient cannot be empty',
          duplicate: 'This recipient is already in the list',
          invalidEmail: 'Invalid email format',
          selectTypeFirst: 'Please select a notification type first',
          enterEmail: 'Please enter an email address',
          enterMobile: 'Please enter a mobile number',
        },
      },
      connectedDevices: {
        empty: 'No device alarms are connected to this alarm system.',
        unnamed: 'Unnamed Alarm',
      },
      confirmDelete: 'Are you sure you want to delete this alarm system?',
      list: {
        new: 'New',
        search: 'Search...',
        empty: 'No alarm systems found',
      },
      updatedSuccess: 'Alarm system updated successfully',
      createdSuccess: 'Alarm system created successfully',
      deletedSuccess: 'Alarm system deleted successfully',
      updateError: 'Error updating alarm system',
      createError: 'Error creating alarm system',
      deleteError: 'Error deleting alarm system',
      fetchError: 'Error fetching alarm systems',
      fetchLogsError: 'Error fetching alarm logs',
    },
    enerskyAccess: {
      list: {
        header: 'Enersky Access Records',
        description:
          'Manage data-sharing access and contract status for customers',
        tableTitle: 'Access records',
        addButton: 'Create record',
        emptyState: 'No records found.',
        searchPlaceholder: 'Search existing records...',
        backButton: 'Back to records',
      },
      columns: {
        vendor: 'Vendor',
        customer: 'Customer',
        status: 'Status',
      },
      validation: {
        missingVendor: 'Vendor is required.',
        missingFirstName: 'First name is required.',
        missingLastName: 'Last name is required.',
        missingEmail: 'Email must be provided and in correct format.',
        missingCompanyName: 'Company name is required for business customers.',
        missingOrganizationNumber: 'Organization number is required.',
        missingNationalId: 'National ID is required.',
      },
      feedback: {
        save: {
          missingInfoTitle: 'Missing information',
          missingInfoMessage: 'Please fill out all required fields.',
          createSuccessTitle: 'Record created',
          createSuccessMessage: 'Record created and contract email sent.',
          updateSuccessTitle: 'Updated',
          updateSuccessMessage: 'Contact details updated.',
          errorTitle: 'Error',
          errorMessage: 'Failed to save.',
          duplicateEndUser: 'This customer already exists in Enersky.',
        },

        refresh: {
          mpidsTitle: 'Subscriptions refreshed',
          mpidsMessage: 'MPID statuses updated.',
          statusTitle: 'Status refreshed',
          statusMessage: 'Record status and MPIDs updated.',
          errorTitle: 'Error',
          errorMessage: 'Failed to refresh data.',
        },

        resend: {
          title: 'Email sent',
          message: 'Contract email resent to customer.',
          errorTitle: 'Error',
          errorMessage: 'Failed to resend contract email.',
        },

        history: {
          title: 'Historical data request queued',
          message: 'Data queued.',
          errorTitle: 'Error',
          errorMessage: 'Failed to queue reading.',
        },
        delete: {
          successTitle: 'Record deleted',
          successMessage: 'The Enersky access record has been deleted.',
          errorTitle: 'Error',
          errorMessage: 'Failed to delete record.',
        },
      },
      editEnerskyAccess: {
        labels: {
          basicInfo: 'Basic information',
          vendor: 'Vendor',
          firstName: 'First name',
          lastName: 'Last name',
          email: 'Email',
          companyName: 'Company name',
          privatePerson: 'Private individual',
          nationalId: 'National ID',
          organizationNumber: 'Organization number',
          systemInfo: 'Enersky access record information',
          accessUrl: 'Access URL',
          requestId: 'Request ID',
          errorMessage: 'Error message',
          mpidSection: 'Metering Points (MPID)',
          mpid: 'MPID',
          meterNumber: 'Meter number',
          address: 'Address',
          description: 'Description',
          priceArea: 'Price area',
          status: 'Status',
          actions: 'Actions',
          deleteConfirmMessage: 'Are you sure you want to delete this record?',
        },

        buttons: {
          resendLink: 'Resend link',
          refreshSubscriptions: 'Refresh subscriptions',
          readHistoricalData: 'Read historical data',
        },

        status: {
          unknown: 'Unknown status',
        },
        none: 'None',
        unknownError: 'Unknown error',
      },
      status: {
        Pending: 'Pending',
        'Contract email sent': 'Contract email sent',
        'Contract link requested': 'Contract link requested',
        Completed: 'Completed',
        Error: 'Error',
        Unknown: 'Unknown status',
      },
    },
    chirpStackKeys: {
      title: 'Imported Key Files',
      addButton: 'Import keys',
      columns: {
        fileName: 'Filename',
        uploadedAt: 'Uploaded at',
        importedCount: 'Imported count',
      },
      importFile: 'Import ChirpStack keys file',
      preview: {
        title: 'Preview',
        noRows: 'No preview rows.',
        close: 'Close',
        cancel: 'Cancel',
        confirm: 'Confirm Import',
      },
      feedback: {
        loadError: 'Failed loading files',
        previewError: 'Preview failed',
        invalidExcel: 'Invalid Excel file.',
        missingFile: 'Original file missing, please re-select',
        importSuccess: 'Import successful',
        importError: 'Import failed',
      },
    },

    icMeterData: 'IC Meter Data',
    energyLabel: 'Energy label:',
    buildingSensorData: 'Building Sensor Data',
    eosSensorData: 'EOS Sensor Data',
    protocol: 'Communication Protocol',
    leads: {
      // contract: 'Contract',
    },
  },

  buildings: {
    sidebar: {
      modifyToggle: 'Modify',
      editBuildingTitle: 'Edit Building',
      buildingOverviewTitle: 'Building Overview',
      editZoneTitle: 'Edit Zone',
      outdoorTemperatureTitle: 'Outdoor Temperature',
      indoorClimateTitle: 'Indoor Climate',
      buildingTemperature: 'Building temperature',
      floorTemperature: 'Floor temperature',
      outdoorTempLabel: 'Outdoor Temp:',
      electricityPriceLabel: 'Electricity Price:',
      energyLabel: 'Energy label:',
      noData: 'No Data',
      aspaTitle: 'ASPA Payload',
      zoneFloors: {
        selectFloorLabel: 'Select Zone Floor:',
        selectBuildingFloorLabel: 'Select Building Floor:',
        changeFloor: '- Change Floor -',
        addFloor: 'Add Floor ',
        groundFloor: 'Ground Floor',
      },
    },
    aspa: {
      title: 'ASPA Settings',
      noPayload: 'No ASPA payload found for this building.',
      avgTemp: 'Average Temperature',
      acrossAllZones: 'Across all zones',
      highestZoneTemp: 'Highest Zone Temp',
      peakZoneReading: 'Peak zone reading',
      lastUpdated: 'Last Updated',
      payloadsReceived: 'payloads received',
      setpointOverview: 'Setpoint Overview',
      hourView: '24-hour view',
      hourOfDay: 'Hour of day',
      dailySetpoint: 'Daily Setpoint (°C)',
      liveSetpoint: 'Live Setpoint (°C)',
      avg: 'Avg',
      peak: 'Peak',
      trends: 'Trends',
      temperature: 'Temperature',
      humidity: 'Humidity',
      noTrendData: 'No trend data.',
      recommendations: 'Recommendations',
      noRecommendations: 'No recommendations found.',
      actionKeys: {
        cool: 'Cool',
        coolingLevel: 'Cooling Level',
        preCool: 'Pre Cool',
        heat: 'Heat',
        heatingLevel: 'Heating Level',
        preHeat: 'Pre Heat',
      },
      items: 'items',
      on: 'On',
      off: 'Off',
      samples: 'samples',
      trendPeriod: 'Last 2 hours',
    },
    details: {
      header: 'Building Details',
      form: {
        buildingName: 'Building Name',
        active: 'Active',
        buildingInformation: 'Building Information',
        buildingType: 'Building Type (NS Standard)',
        buildingCategory: 'Building Category',
        constructionYear: 'Construction Year',
        numberOfFloors: 'Number of Floors',
        netUsableFloorArea: 'Net Usable Floor Area (m²)',
        gridRegion: 'Grid Region',
        selectGridRegion: '- Select Area -',
        mix: 'CO2 Mix',
        addressAndGps: 'Address & GPS',
        street: 'Street',
        street2: 'Street 2',
        postCode: 'Post Code',
        city: 'City',
        country: 'Country',
        latitude: 'Latitude',
        longitude: 'Longitude',
        fetchGps: 'Fetch GPS',
        fillStreetCityError:
          'Please fill in both Street and City to fetch GPS coordinates.',
        requiredAddressFields: '{fields} must be filled in before saving.',
        searchCountry: 'Search country',
        floorNumber: 'Floor Number',
        preferredCurrency: 'Preferred Currency',
        climateGoalPercentage: 'Climate Goal Percentage',
        changeModel: 'Change building model',
        defaultStartingFloor: 'Starting floor',
        startingViewHint:
          'Rotate, pan and zoom the preview to set the view the building opens with.',
        matrikkelData: {
          title: 'Matrikkel',
          error: 'Failed to fetch matrikkel data',
          errorTitle: 'Error',
          matrikkelId: 'Matrikkel ID',
          cadastralNumber: 'Cadastral Number',
          propertyUnitNumber: 'Property Unit Number',
          sectionNumber: 'Section Number',
          unitNumber: 'Units',
          leaseholdNumber: 'Leasehold Number',
          municipalityName: 'Municipality Name',
          municipalityNumber: 'Municipality Number',
          success: 'Success',
          fetchMatrikkelData: 'Fetch Matrikkel Data',
          buildingNumber: 'Building Number',
          errorMissing: 'Missing required address fields',
          errorTooMany: 'Too many addresses found',
          errorNotFound: 'No address found',
          unitId: 'Unit ID',
          noUnitIdFound:
            'Not unit was found on this address. Please verify address against seeiedom.no and try again.',
          sectionTitle: 'Building Unit',
          sectionsTitle: 'Sections',
          fetchedFromMatrikkel: 'Fetched from matrikkel',
          overrideButton: 'Override building unit',
          overrideSectionButton: 'Override section',
          addButton: 'Add building unit',
          addSectionButton: 'Add section',
          manualWarning:
            'Only necessary if matrikkel data is missing or incorrect.',
          buildingType: 'Building Type',
        },
      },
      baseline: {
        title: 'Baseline',
        recalcButton: 'Re-calculate Baseline',
        confirmRecalculate:
          'Are you sure you want to re-calculate the baseline?',
        success: 'Baseline recalculated successfully',
        error: 'Failed to recalculate baseline',
        subscriptions: {
          title: 'Elhub subscriptions',
          loading: 'Loading subscriptions...',
          emptyState: 'No subscriptions found. Add a new one below.',
          actions: {
            unsubscribe: 'Unsubscribe',
            subscribe: 'Subscribe',
            delete: 'Delete',
            addPlaceholder: 'Enter Metering Point ID',
            status: {
              waitingApproval: 'Waiting for customer to approve Elhub request',
            },
            validation: {
              onlyDigits: 'Metering Point ID must contain only digits',
              exactLength:
                'Metering Point ID must be exactly 18 digits (e.g. 707057500042153290)',
              startsWith: 'Metering Point ID must start with 7070575000',
              unique: 'Metering Point ID must be unique',
            },
            move: {
              selectTargetBuilding: '- Select target building -',
              moveSelected: 'Move Selected',
              instructions:
                'Select subscriptions by checking the boxes. This may take up to 1 minute per subscription.',
              moveSubscriptions: 'Move Subscriptions',
            },
            feedback: {
              subscribeSuccess: 'Subscription request sent',
              unsubscribeSuccess: 'Unsubscribed successfully',
              deleteSuccess: 'Subscription deleted',
              subscribeError: 'Failed to send subscription request',
              unsubscribeError: 'Failed to unsubscribe',
              deleteError: 'Failed to delete subscription',
            },
          },
        },
      },
      report: {
        title: 'Report',
      },
    },
    model3d: {
      title: '3D Model',
    },
    zoneEdit: {
      title: 'Zone settings',
      form: {
        zoneName: 'Zone Name',
        floorNumber: 'Floor Number',
        selectCategory: 'Select a category',
        isHeated: 'Heated zone',
        displayHint: 'How the zone appears in the 3D view.',
        cardSize: 'Card size',
        zoneColor: 'Zone color',
        devices: {
          availableDevices: 'Available Devices',
          zoneDevices: 'Zone Devices',
          noMatches: 'No devices match the search',
        },
        deleteButton: 'Delete Zone',
        deleteZoneDescription: 'Removes the zone permanently.',
        deleteZoneConfirm: 'Are you sure you want to delete this zone?',
        deleteError: 'Failed to delete zone',
      },
    },
    technicalRoom: {
      titles: 'Technical Rooms',
      emptyState: 'No technical rooms found.',
      technicalRoomDescription: 'Description of the technical room',
      technicalRoomNamePlaceholder: 'Name of technical room',
      technicalRoomDevices: 'Devices in technical room',
      addDevice: 'Add device',
      technicalRoomDevice: 'Technical room device',
      removeDevice: 'Remove',
      searchPlaceholder: 'Search technical room',
      technicalRoomOverview: 'Technical Rooms',
      technicalRoomValue: 'Value',
      technicalRoomSeen: 'Last seen',
      addTechnicalRoom: 'Add Technical Room',
      addDeviceButton: 'Add Device',
      removeDeviceButton: 'Remove',
      deviceType: 'Device Type',
      editorTitle: 'Technical Rooms',
      selectRoom: 'Select a technical room',
      threeDModel: '3D Model',
      replace: 'Replace',
      selectModel: 'Select a 3D model',
      modelDefaultsGroup: 'Default models',
      noModel: 'No 3D model attached to this room.',
      bind: 'Bind',
      rebind: 'Rebind',
      unbind: 'Unbind',
      boundTo: 'Bound to',
      notBound: 'Not bound',
      hide: 'Hide in 3D',
      show: 'Show in 3D',
      size: 'Size',
      remove: 'Remove from room',
      pickingHint: 'Click the model to bind',
      pickingCardHint:
        'Click a part of the model, or the background to place the card freely',
      searchDevices: 'Search devices…',
      noDevicesAvailable: 'No devices available',
      noMatches: 'No matches',
      unnamedDevice: 'Unnamed device',
      couldNotAddDevice: 'Could not add device',
      noReadings24h: 'No readings in the last 24 hours',
      dragToReposition: 'Drag to reposition',
      hideGraph: 'Hide graph',
      showGraph: 'Show graph',
      lockedHint: 'Unlock the view to move devices',
      clickToEdit: 'Click to edit',
      noDescription: 'No description',
      noTitle: 'No title',
      showCardTitle: 'Card title',
      showDeviceName: 'Device name',
      cardVisualization: 'Card visualization',
      modelAnimation: 'Model animation',
      showLine: 'Leader line',
      lineColor: 'Line color',
      resetColor: 'Reset color',
      darkTheme: 'Dark theme',
      showUnit: 'Unit',
      trendLine: 'Trend line',
      trendBars: 'Trend bars',
      showUpdated: 'Last updated',
      visualizationRules: 'Visualization rules',
      ruleDataKey: 'Data key',
      ruleValue: 'Value',
      triggers: 'Triggers',
      addTrigger: 'Add trigger',
      ruleOff: 'Off',
      ruleSlow: 'Slow',
      ruleFast: 'Fast',
      ruleNoEffect: 'No effect',
      ruleNoColor: 'No color',
      ruleReverse: 'Reverse direction',
      particleFlow: 'Particle flow',
      drawFlow: 'Draw flow',
      flowHint: 'Click the model to add points.',
      flowFollowsHint:
        'The particles follow the model animation triggers. When the animation is off, the particles stop.',
      flowColorHint:
        'Click a point on the flow in the model to change its color from there on.',
      flowColorFromPoint: 'Color from selected point',
      flowFollows: 'Follows animation',
      particles: 'Particles',
      ruleDataKeyRequired: 'Select a data key for the visualization rule',
      newTechnicalRoom: 'New technical room',
      roomNamePlaceholder: 'e.g. Ventilation, Boiler room, Heat pump',
      selectBuilding: 'Select a building',
      nameRequired: 'Name is required',
      buildingRequired: 'Building is required',
      couldNotCreateRoom: 'Could not create room',
      creating: 'Creating',
      loadError: 'Failed to load technical room',
      textPlaceholder: 'Type text…',
      noText: 'No text',
      linkToRoom: 'Go to room',
      noLink: 'No link',
      linkHint:
        'In the locked view a click on the model or the card opens this room.',
      confirmRemoveAnnotation:
        'Are you sure you want to remove this text from the room?',
      dragToReorder: 'Drag to reorder',
      drawFrame: 'Draw frame',
      redrawFrame: 'Redraw frame',
      frameDrawHint: 'Click two corners on the drawing',
      noFrame: 'No frame drawn',
      frameDrawn: 'Frame drawn',
      confirmRemoveFrame:
        'Are you sure you want to remove this frame from the room?',
      confirmRemoveLink:
        'Are you sure you want to remove this link from the room?',
      annotationsTab: 'Links and text',
      noAnnotations: 'No links or text in this room.',
      placeText: 'Place',
      replaceText: 'Place again',
      placed: 'Placed',
      placeTextHint: 'Click the drawing where the text should sit',
      placeInfoHint: 'Click the drawing where the bubble should sit',
      confirmRemoveInfo:
        'Are you sure you want to remove this info bubble from the room?',
      ruleAngle: 'Angle (degrees)',
      infoPanel: 'Alarms and operating calendar',
      alarmsTab: 'Alarms',
      calendarsTab: 'Operating calendar',
      noAlarmSystems: 'No alarm systems are connected to this room.',
      noCalendars: 'No operating calendars are connected to this room.',
      systemAlarm: 'System alarm',
      openInSettings: 'Open in settings',
      confirmRemoveDevice:
        'Are you sure you want to remove this device from the room?',
      attributes: 'Attributes',
      selectAttribute: 'Select an attribute',
      mappedGroup: 'Mapped attributes',
      payloadGroup: 'Payload',
      mappedNoneText: 'None available,',
      assignHere: 'assign here',
      confirmDeleteRoom: 'Are you sure you want to delete {name}?',
      roomDeleted: 'Technical room deleted',
      renameRoom: 'Rename technical room',
      noTechnicalRoomsForType: 'No technical rooms of this type found',
      noDevices: 'No devices in this technical room.',
      technicalRoomTypeLabel: 'Technical Room Type',
      technicalRoomTypes: {
        type: 'Select type',
        hvac: 'HVAC',
        technical: 'Technical Room',
        electrical: 'Electrical',
        plumbing: 'Plumbing',
        other: 'Other',
      },
      message: {
        success: 'Technical room successfully created',
        updateSuccess: 'Technical room successfully updated',
        deleteSuccess: 'Technical room successfully deleted',
        error: 'An error occurred while processing your request',
        deleteConfirm: 'Are you sure you want to delete this technical room?',
      },
    },
  },

  threeD: {
    lockView: 'Lock view',
    unlockView: 'Unlock view',
  },

  buildings3D: {
    header: {
      buildingTab: 'Building',
      technicalTab: 'Technical',
    },
    footer: {
      home: 'Home',
      measure: 'Measure',
      stopMeasure: 'Stop Measure',
      explode: 'Explode',
      screenshot: 'Screenshot',
      lock: 'Lock',
      unlock: 'Unlock',
    },
    climate: {
      buildingClimate: 'Indoor Environment',
      levelsTitle: 'Sections',
      startLabel: 'Start',
      endLabel: 'End',
      apply: 'Apply',
      avgTemperature: 'Average temperature',
      avgHumidity: 'Average humidity',
      avgCo2: 'Average CO₂',
      floor: 'Floor',
      wholeBuilding: 'Whole building',
      noTrendData: 'No data',
      fetchData: 'Fetch Data',
      startMustBeBeforeEnd: 'Start must be before End.',
      groundFloor: 'Ground floor',
      weekdaysShort: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
    },
    status: {
      good: 'Normal',
      tooLow: 'Too low',
      tooHigh: 'Too high',
      warning: 'Warning',
      poor: 'Poor',
    },
    warnings: {
      title: 'Warnings',
      highCo2: 'High CO₂',
      highTemp: 'High temperature',
      lowTemp: 'Low temperature',
    },
    alarmLog: {
      title: 'Alarm log',
      last24h: 'Last 24 hours',
      last7d: 'Last 7 days',
      last30d: 'Last 30 days',
      custom: 'Custom',
      zone: 'Zone',
      activeNow: 'Active now',
      today: 'Today',
      yesterday: 'Yesterday',
      earlier: 'Earlier',
      empty: 'No alarms in this range',
      loadError: 'Could not load the alarm log.',
      unknownZone: 'Unknown zone',
    },
    deviceLayer: {
      moveDevices: 'Move models',
      moveHint: 'Drag to move · ⇧ rotate · ⌘ height',
      moveThisDevice: 'Move this device',
      doneMoving: 'Done moving',
      changeModel: 'Change model',
      showDataBox: 'Show data box',
      hideDataBox: 'Hide data box',
      modelSize: 'Model size',
      dataSize: 'Data size',
      hideZones: 'Hide zones',
      showZones: 'Show zones',
      hideModels: 'Hide models',
      showModels: 'Show models',
      hideModel: 'Hide model',
      showModel: 'Show model',
      suggested: 'Suggested',
      noModelsInCategory: 'No models in this category yet',
      controllers: 'Controllers',
      models: {
        radiatorGlb: 'Radiator',
        panelOvenGlb: 'Panel oven',
        heatpumpGlb: 'Heat pump',
        indoorClimateGlb: 'Indoor climate',
        icmSensorGlb: 'ICM sensor',
        climateHubGlb: 'Climate hub',
        ventilationOutletGlb: 'Ventilation outlet',
        ventilationGrillGlb: 'Ventilation grille',
      },
    },
    zoneControls: {
      leaveFloor: 'Leave',
      drawZone: 'Double-click to finish',
      clearZones: 'Clear zones',
      clickFloorToIsolate: 'Click floor to isolate',
      select: 'Select',
      rectangle: 'Rectangle',
      circle: 'Circle',
      polygon: 'Polygon',
      zoneNameLabel: 'Zone name',
      heightLabel: 'Height',
      editVertexHint: 'Drag the points to edit, double-click point to add more',
      unnamedZone: 'Unnamed zone',
      zoneNameRequired: 'Zone name is required',
      zonesMissingData: 'Zones missing 3D data',
      zonesMissingDataTitle: 'Zones missing 3D model data:',
      floorLabel: 'Floor',
      zoneCreated: 'Zone created',
      zoneUpdated: 'Zone updated',
      zoneDeleted: 'Zone deleted',
      failedToCreateZone: 'Failed to create zone',
      failedToUpdateZone: 'Failed to update zone',
      failedToDeleteZone: 'Failed to delete zone',
      confirmDeleteZoneTitle: 'Delete zone?',
      confirmDeleteZoneMessage:
        'Are you sure you want to delete this zone? This action cannot be undone.',
    },
  },

  deviceAlarms: {
    updatedSuccess: 'Device alarm updated successfully',
    createdSuccess: 'Device alarm created successfully',
    deletedSuccess: 'Device alarm deleted successfully',

    editTitle: 'Edit Device Alarm',
    createTitle: 'Create Device Alarm',
    title: 'Device Alarms',
    manageAlarmsForDevice: 'Manage alarms for {device}',
    recipients: 'Recipients',

    alarmDetails: 'Alarm Details',
    deviceSelection: 'Device Selection',
    alarmConditions: 'Alarm Conditions',
    condition: 'Condition',
    conditions: 'Conditions',
    noConditions: 'No conditions added yet.',
    noConditionsSaveError: 'At least one condition is required',

    name: 'Name',
    description: 'Description',
    alarmSystem: 'Alarm System',
    selectDevice: 'Select Device',
    dataKey: 'Data Key',
    selectKey: 'Select Key',
    level: 'Level',
    operator: 'Operator',
    value: 'Value',
    duration: 'Duration (min)',
    message: 'Message',
    active: 'Active',

    greaterThan: 'Greater Than',
    lessThan: 'Less Than',
    equal: 'Equal',
    notEqual: 'Not Equal',
    missing: 'Missing',
    unchanged: 'Unchanged',

    addTrigger: 'Add Trigger',
    addCondition: 'Add Condition',
    triggers: 'Triggers',

    standardDevices: 'Standard Devices',
    eosDevices: 'EOS Devices',
    noDataKeys: 'No data keys available for this device.',

    noAlarmSystems: 'No alarm systems available.',
    pleaseCreateFirst: 'Please create one first',
    selectDeviceFirst:
      'Please select a device first to configure alarm conditions.',
    messagePlaceholder: 'Alert message to display...',
    confirmDelete: 'Are you sure you want to delete this device alarm?',
    list: {
      new: 'New',
      search: 'Search...',
      empty: 'No device alarms found',
    },
    deleteAlarmTitle: 'Delete Alarm',
    deleteAlarmDescription: 'This action cannot be undone.',
  },

  settings: {
    areas: {
      home: 'Home',
      vendor: 'General',
      devices: 'Devices',
      eos_devices: 'EOS Devices',
      categories: 'Categories',
      users: 'Users',
      themes: 'Themes',
      integrationOverview: 'API Integrations',
      fileCloud: 'File Cloud',
      energyPrices: 'Energy Prices',
      alarms: 'Alarms',
      alarmSystemDescription:
        'Manage and customize alarm systems with tailored notifications and heartbeat monitoring to stay informed about critical events and ensure timely responses.',
      baseline: 'Baseline',
      technicalRoomOverview: 'Technical Rooms',
      aspaSetup: 'ASPA Setup',
      controlStrategy: 'Control Strategy',
      operatingCalendar: 'Operating Calendars',
      setpoint: 'Setpoints',
    },

    home: {
      title: 'Company Dashboard',
      tagline:
        'Manage your company settings, users, devices, and themes in one place',
    },

    dashboardItems: {
      themes: {
        title: 'Themes',
        description: 'Create and manage color themes for your application',
        linkText: 'View Themes',
      },
      users: {
        title: 'Users',
        description: 'Manage user accounts and permissions',
        linkText: 'View Users',
      },
      eosDevices: {
        title: 'EOS Devices',
        description: 'Monitor and manage Energy Monitoring sensors',
        linkText: 'View EOS Devices',
      },
      settings: {
        title: 'Settings',
        description: 'Configure system-wide application settings',
        linkText: 'View Settings',
      },
      devices: {
        title: 'Devices',
        description: 'Configure and monitor connected devices',
        linkText: 'View Devices',
      },

      fileCloud: {
        title: 'File Cloud',
        description: 'Store, organize and share files across your organization',
        linkText: 'View Files',
      },
      integration: {
        title: 'API Integrations',
        description: 'Configure and manage API connections and integrations',
        linkText: 'View Integrations',
      },
      categories: {
        title: 'Categories',
        description: 'Create and manage device categories',
        linkText: 'View Categories',
      },
    },

    topics: {
      addButton: 'Add Topic',
      eosName: 'EOS Name',
      sensorTag: 'Sensor Tag',
      sensorTagRequired: 'Sensor Tag is required',
      sensorTagTooShort: 'Sensor Tag must be at least 3 characters',
      assignedTo: 'Used by',
      aggregator: {
        title: 'Aggregator',
        sum: 'Sum',
        average: 'Average',
        max: 'Max',
        min: 'Min',
        cumulative: 'Cumulative',
        differential: 'Differential',
        last: 'Last',
      },
      scale: 'Scale',
      decimals: 'Decimals',
      units: 'Units',
      removeButton: 'Remove',
      deleteTopic: 'Delete Topic',
      confirmDelete: 'Are you sure you want to delete this topic?',
    },
    devices: {
      installNetmoreButton: 'Install Netmore Device',
      gatewayInstaller: 'Gateway Installer',
      gatewayEUI: 'Gateway EUI',
      installChirpStackButton: 'Install ChirpStack Device',
      serialNumber: 'Serial Number',
      bulkSerialsLabel: 'Serial Numbers (comma or new line)',
      ui: {
        singleModeTitle: 'Single device',
        bulkModeTitle: 'Bulk install',
        bulkNameHintLine1: 'Name is empty -> serial numbers are used as names',
        bulkNameHintLine2: 'Name is set -> all bulk devices use the same name',
      },
      visualToggle: {
        visualToggleDevice: 'Visual Toggle Devices',
        visualToggleBuilding: 'Building',
        visualToggleDelimiter: 'Delimiter',
        visualToggleDataKey: 'Data Key',
        visualToggleProperty: 'Property',
        visualTogglePropertyId: 'Property ID',
        visualToggleValue: 'Value',
        visualToggleColor: 'Color',
        visualToggleTriggers: 'Triggers',
        visualToggleAddTrigger: 'Add Trigger',
        visualToggleRemove: 'Remove Trigger',
        visualToggleSelectBuilding: 'Select Building',
        visualToggleSelectValue: 'Select Value',
        visualToggleDev: 'Device',
        visualToggleOverview: 'Visual Toggle Overview',
        visualToggleAdd: 'Add Visual Toggle Device',
        visualToggleGlobalModels: 'Global 3D models',
        visualToggleDelete: 'Delete Visual Toggle Device',
        visualToggleNoDevices: 'No Visual Toggle Devices found.',
        visualToggleSearchPlaceholder: 'Search Visual Toggle Devices...',
        visualToggleName: 'Name',
        visualToggleTechnicalRoom: 'Technical room',
        visualToggleSelectRoom: 'Select a technical room',
        visualToggleBuildingRequired: 'Building is required',
        visualToggleTechnicalRoomRequired: 'Technical room is required',
        visualToggleDeviceRequired: 'Device is required',
        visualtoggleAxes: {
          xAxis: 'Rotation X',
          yAxis: 'Rotation Y',
          zAxis: 'Rotation Z',
          off: 'Off',
          half: 'Half',
          full: 'Full',
          none: 'None',
        },
        feedback: {
          visualToggleDeleteConfirm:
            'Are you sure you want to delete this Visual Toggle Device?',
          visualToggleDeleteSuccess:
            'Visual Toggle Device successfully deleted',
          visualToggleDeleteError:
            'An error occurred while trying to DELETE the Visual Toggle Device',
          visualToggleDataKey: 'Missing data key',
          visualToggleTrigger: 'Missing trigger',
          visualToggleProperty: 'Property is required.',
          visualToggleValue: 'Value is required.',
          visualToggleUpdated: 'Visual Toggle Device successfully updated',
          visualToggleCreated: 'Visual Toggle Device successfully created',
          visualToggleSaveError:
            'An error occurred while trying to SAVE the Visual Toggle Device',
        },
      },
      deviceControls: {
        title: 'Device Controls',
        send: 'Send',
        updateSuccessMessage: 'Setpoint updated successfully',
        updateSuccessTitle: 'Success',
        updateErrorTitle: 'Error',
        updateErrorMessage: 'Failed to update setpoint',
        hideAdvanced: 'Hide advanced settings',
        showAdvanced: 'Show advanced settings ({count} devices)',
        current: 'Current value',
        range: 'Range',
        duration: 'Duration (hours)',
        durationHelp: 'The setpoint returns to the schedule after this',
        comment: 'Comment',
        commentPlaceholder: 'Why is this being overridden?',
        notLogged: 'Setpoint updated, but the override could not be logged',
      },
      list: {
        header: 'Device Management',
        addButton: 'Add device',
        emptyState: 'No devices found.',
        searchPlaceholder: 'Search devices...',
        backButton: 'Back to devices',
      },
      validation: {
        nameRequired: 'Device name is required',
        sensorTagMissing: 'Sensor Tag is missing for topic {{index}}.',
        sensorTagTooShort:
          'Sensor Tag for topic {{index}} must be at least 3 characters long.',
      },
      feedback: {
        updateSuccess: 'Device successfully updated',
        updateError: 'An error occurred while trying to UPDATE the device',
        createSuccess: 'Device successfully created',
        installSuccess: 'Device successfully installed',
        createError: 'An error occurred while trying to CREATE the device',
        duplicateDevice: 'Device with this serial number already exists.',
        saveError: 'An error occurred while trying to SAVE the device',
        missingAttributes: 'We need all the required fields to be filled out',
        validationError: 'Validation error',
        serviceUnavailable:
          'Service is temporarily unavailable. Please try again later.',
        bulkInstallSummary:
          'Installed: {installed}. Duplicates: {duplicates}. Failed: {failed}.',
      },
    },

    eosDevices: {
      list: {
        header: 'EOS Devices',
      },
      validation: {
        sensorTagMissing: 'Sensor Tag is missing for topic {{index}}.',
        sensorTagTooShort:
          'Sensor Tag for topic {{index}} must be at least 3 characters long.',
      },
      feedback: {
        updateSuccess: 'Device successfully updated',
        updateError: 'An error occurred while trying to UPDATE the device',
        createSuccess: 'Device successfully created',
        createError: 'An error occurred while trying to CREATE the device',
        saveError: 'An error occurred while trying to SAVE the device',
      },
      energyCategories: {
        electricityGrid: 'Electricity (Grid)',
        electricityGridExport: 'Exported Electricity (Grid)',
        districtHeating: 'District Heating',
        districtCooling: 'District Cooling',
        fossilFuels: 'Fossil Fuels',
        biofuels: 'Biofuels',
        solarPV: 'Solar PV',
        solarThermal: 'Solar Thermal',
        otherRenewables: 'Other Renewables (Wind, Geothermal)',
        wasteHeat: 'Waste Heat',
      },
    },

    editDevice: {
      title: 'Edit Device',
      newTitle: 'New Device',
      deviceName: 'Device Name',
      setpointRange: 'Setpoint Range',
      setpointRangeInfo:
        'Set the upper and lower setpoint values for the sensor tag, as well as the step size used between the setpoints.',
      minSetpoint: 'Min Setpoint',
      maxSetpoint: 'Max Setpoint',
      stepSize: 'Step Size',
      controlMode: {
        label: 'Control Mode',
        info: 'Determines how the device is regulated when control is triggered.\nStep: Gradually adjusts the setpoint up/down by the step size per run, within min/max.\nBinary: Jumps directly to max (more heating/ventilation) or min (less). On/off control.\nSchedule: Follows opening hours only — max within, min outside. Ignores ASPA actions.\nSetpoint: Writes the desired setpoint directly, limited to min/max. Only updates when the deviation exceeds ±0.1.',
        step: 'Step',
        binary: 'Binary',
        schedule: 'Schedule',
        setpoint: 'Setpoint',
      },
      operatingHoursOnly: 'Only control within operating hours',
      dynamicSetpoints: {
        label: 'Dynamic Setpoints',
        info: 'Dynamic setpoints let the device override its setpoint range based on other sensor values. When the sensor value in the sensor tag meets the condition (operator + threshold), the min setpoint, max setpoint and step size from the entry are used instead of the device’s normal setpoint range.\nSensor tag: the sensor tag being monitored (e.g. cooling coil output).\nOperator/threshold: the condition that must be met for the override to be active.\nMin/max setpoint and step size: the setpoint range that applies while the condition is met.',
        add: 'Add Dynamic Setpoint',
        deleteTitle: 'Remove Dynamic Setpoint',
        confirmDelete: 'Are you sure you want to remove this dynamic setpoint?',
        operator: 'Operator',
        threshold: 'Threshold',
        validationError:
          'All fields must be filled out to add a dynamic setpoint.',
        fieldRequired: 'Required',
      },
      deviceDescription: 'Device Description',
      deviceProfile: 'Device Profile',
      selectDeviceProfile: '- Select Device Profile',
      controllerSettings: 'Controller Settings',
      status: {
        active: 'Active',
        displayInZone: 'Display in Zone',
      },
      display: 'Display',
      icon: 'Icon',
      deviceType: {
        label: 'Device Type',
        selectDefault: '- Select Device Type',
        sensor: 'Sensor',
        controller: 'Controller',
      },
      dataReceiver: {
        label: 'Data Receiver',
        selectDefault: '- Select Data Receiver',
        info: 'Choose which receiver should receive control values for this device.',
      },
      deviceCategory: {
        label: 'Device Category',
        selectDefault: 'Select a category',
      },
      valueMap: 'Map device values to text (optional)',
      setValueMapping: 'Set value mapping',
      mappedAttribute: {
        label: 'Mapped Attribute',
        attribute: 'Attribute',
        numberValue: 'Number',
        textValue: 'Text',
        duplicateValueMapping: 'Value already exists!',
        cancelEditValueMapping: 'Cancel',
        removeValueMapping: 'Remove',
        editValueMapping: 'Edit',
        deleteTitle: 'Delete value mapping',
        confirmDeleteValueMapping:
          'Are you sure you want to delete this value mapping?',
        confirmDeleteMappedAttributeTitle: 'Delete mapped attribute',
        confirmDeleteMappedAttribute:
          'Are you sure you want to delete this mapped attribute?',
      },
      topics: 'Topics',
      inspectDevice: 'Inspect Device',
      deleteButton: {
        deleting: 'Deleting...',
        label: 'Delete Device',
      },
      confirmDelete: 'Are you sure you want to delete this device?',
    },
    editEosDevice: {
      title: 'Edit EOS Device',
      newTitle: 'New EOS Device',
      deviceName: 'Device Name',
      topics: 'Topics',
      deviceDescription: 'Device Description',
      active: 'Active',
      producingPower: 'Producing Power',
      includeInBaseline: 'Include in Baseline',
      deviceSettings: 'Device Settings',
      energyCategory: { label: 'Energy Category' },
      provider: {
        label: 'Provider',
        required: 'Provider is required for district heating',
        options: {
          hafslund: 'Hafslund (Celsio)',
          luneraEnergi: 'Lunera Energi',
        },
      },
      building: 'Building',
      allBuildings: 'All Buildings',
      sensorTypes: {
        HEAT: 'Heat',
        LIGHT: 'Light',
        HVAC: 'HVAC',
        PRODUCTION: 'Production',
        OFFICE: 'Office',
        OTHER: 'Other',
      },
      icon: 'Icon',
      deviceType: {
        label: 'Device Type',
        selectDefault: '- Select Device Type',
        eosSensor: 'EOS Sensor',
        eosSource: 'EOS Source',
      },
      sensorConfiguration: 'Sensor Configuration',
      deviceCategory: {
        label: 'Device Category',
        selectDefault: 'Select a category',
      },
      sources: 'Sources',
      inspectDevice: 'Inspect Device',
      deleteButton: {
        deleting: 'Deleting...',
        label: 'Delete EOS device',
      },
      confirmDelete: 'Are you sure you want to delete this device?',
    },

    categories: {
      list: {
        header: 'Categories',
        addButton: 'Add category',
        emptyState: 'No categories found.',
        searchPlaceholder: 'Search categories...',
        backButton: 'Back to categories',
      },
      feedback: {
        updateSuccess: 'Category successfully updated',
        updateError: 'An error occurred while trying to UPDATE the Category',
        createSuccess: 'Category successfully created',
        createError: 'An error occurred while trying to CREATE the Category',
        saveError: 'An error occurred while trying to SAVE the Category',
      },
    },
    editCategory: {
      parentCategory: 'Parent Category',
      legend: 'Language',
      categoryName: 'Category name:',
      languageType: 'Type of language:',
      selectLanguage: 'Select language',
      categoryDescription: 'Category description:',
      deleteCategory: 'Delete Category',
      deleteConfirm: 'Are you sure you want to delete this category?',
      categoryType: 'Category type',
      validation: {
        categoryRequired: 'At least one category type is required',
        languageRequired: 'Language is required',
      },
      languageOptions: {
        en: 'English',
        no: 'Norwegian',
        se: 'Swedish',
        de: 'German',
        fr: 'French',
        es: 'Spanish',
      },
      categoryTypes: {
        device: 'Device',
        zone: 'Zone',
        service: 'Service',
        resource: 'Resource',
        activity: 'Activity',
      },
    },

    userManagement: {
      auditLogs: {
        viewed: 'Viewed',
        doneBy: 'Done by',
        noAccess:
          'You need level 4 (System Admin) or higher to see audit logs.',
      },
      auditChanges: {
        readQuery: 'What was read',
        title: 'What changed',
        field: 'Field',
        before: 'Before',
        after: 'After',
        created: 'Created',
        updated: 'Updated',
        deleted: 'Deleted',
        empty: 'No database changes were recorded for this request.',
        more: 'More records were changed than are shown here.',
        hidden: 'Hidden',
        largeValue: 'Large value',
        items: 'items',
        sentData: 'Data sent',
      },
      list: {
        header: 'User Management',
        addButton: 'Add user',
        emptyState: 'No users found.',
        searchPlaceholder: 'Search users...',
        backButton: 'Back to users',
      },
      feedback: {
        fetchError: 'An error occurred while trying to fetch users',
        updateSuccess: 'User successfully updated',
        updateError: 'An error occurred while trying to UPDATE the user',
        createSuccess: 'User successfully created',
        createError: 'An error occurred while trying to CREATE the user',
        saveError: 'An error occurred while trying to SAVE the user',
      },
    },

    editUser: {
      firstName: 'First Name',
      lastName: 'Last Name',
      userInformation: 'User Information',
      mobileNumber: 'Mobile Number',
      email: 'Email',
      password: 'Password',
      enovaOrganization: 'Organization',
      enovaOrganizationNumber: 'Org nr.',
      enovaPersonalGuid: 'Enova GUID',
      azureAccount: 'Azure Account ID',
      role: 'Role',
      active: 'Active',
      acceptEmails: 'Accept Emails',
      receiveEmails: 'User receives system emails',
      canLogin: 'User can login and access the system',
      hideFeedback: 'Hide Feedback',
      hidePopups: 'Hide feedback popups',
      changePassword: 'Change Password',
      successUpdatePassword: 'Password updated successfully',
      errorUpdatePassword: 'Failed to update password',
      passwordFeedback: 'Password must be at least 8 characters long',
      addNew: 'Add New User',
      calendarSetup: 'Calendar Setup',
      calendarStartOfDay: 'Start of day (for calendar view)',
      calendarEndOfDay: 'End of day',
      tenantAccess: {
        header: 'Tenant Access',
        label: 'Tenant',
        addAccess: 'Add Access',
        selectTenant: '- Select Tenant -',
        assignedTenants: 'Assigned Tenants',
        fetchFailed: 'Failed to fetch tenants',
        feedback: {
          pleaseSelect: 'Please select a tenant',
          alreadyAdded: 'Tenant already added',
        },
      },
      deleteUser: {
        label: 'Delete user',
        deleting: 'Deleting...',
      },
      confirmDelete: 'Are you sure you want to delete this user?',
      activityLog: 'Activity Log',
    },

    integrationOverview: {
      edit: {
        details: {
          legend: 'Details',
          nameLabel: 'Name',
          activeLabel: 'Active',
        },
        access: {
          legend: 'Access',
          accessLevelLabel: 'Access Level',
          dateFromLabel: 'Date From',
          dateToLabel: 'Date To',
          accessLevelOptions: {
            noAccess: 'No Access',
            readOnly: 'Read Only',
            readAndWrite: 'Read and Write',
            admin: 'Admin',
          },
        },
        secrets: {
          legend: 'Secrets',
          revealButton: 'Reveal',
          publicKeyLabel: 'Public Key',
          secretKeyLabel: 'Secret Key',
        },
      },
      feedback: {
        updateSuccess: 'Integration updated',
        createSuccess: 'Integration created',
        saveError: 'Failed to save',
        fetchSecretsError: 'Failed to fetch secrets',
        fetchIntegrationsError: 'Failed to fetch integrations',
      },
    },

    themeSettings: {
      header: {
        title: 'Themes',
        subtitle: 'Create and manage the visual themes for your company',
      },
      feedback: {
        activatedSuccess: '{themeName} theme activated successfully',
        deletedSuccess: 'Theme deleted successfully',
        updatedSuccess: 'Theme updated successfully',
        createdSuccess: 'Theme created successfully',
      },
      card: {
        customize: 'Customize',
        fallbackDescription: 'A {name} theme',
        confirmDelete: 'Are you sure you want to delete the theme "{name}"?',
      },
      globalThemes: {
        sunsetOrange: {
          name: 'Sunset Orange',
          description: 'Warm orange and coral tones with sandy accents',
        },
        oceanBlue: {
          name: 'Ocean Blue',
          description: 'Refreshing blue tones inspired by the ocean',
        },
        crimsonRed: {
          name: 'Crimson Red',
          description: 'Bold crimson driven by energetic red hues',
        },
        forestGreen: {
          name: 'Forest Green',
          description: 'Calming forest greens with natural accents',
        },
        blackAndWhite: {
          name: 'Black & White',
          description: 'Timeless black and white contrast for a modern look',
        },
        classicGray: {
          name: 'Classic Gray',
          description: 'Professional gray theme with subtle contrasts',
        },
        modernWhite: {
          name: 'Modern White',
          description: 'Timeless white for a clean, minimalist aesthetic',
        },
      },
      dialog: {
        editHeader: 'Edit Theme',
        createHeader: 'Create Theme',
        createTitle: 'Create New Theme',
        createDescription: 'Design a custom theme with your colors and style',
        namePlaceholder: 'Name of your theme',
        descriptionPlaceholder: 'Describe your theme (optional)',
        iconHover: 'Icon Hover',
        nameRequired: 'Theme name is required',
        customSuffix: '(Custom)',
      },
    },

    vendor: {
      title: 'General',
      form: {
        name: 'Name',
        contactDetails: 'Contact details',
        street: 'Street',
        postcode: 'Postcode',
        city: 'City',
        country: 'Country',
        timezone: 'Timezone',
        selectTimezone: 'Set timezone',
        organizationNumber: 'Org. Nr',
        phone: 'Contact Phone',
        email: 'Contact email',
        website: 'Link to company website',
        languageDefault: 'Language default',
        selectLanguage: 'Set language',
      },
      modules: {
        title: 'Modules',
        threeDView: '3D View',

        requiredAttributes: {
          title: 'Required attributes',
          firstName: 'Firstname',
          lastName: 'Lastname',
          phone: 'Phone',
          email: 'Email',
        },
        buildingAutomation: {
          title: 'Building Automation',
          sastechTenantId: 'Sastech Tenant Id',
          ignitionProjectName: 'Ignition project name',
          gridRegion: 'Grid Region',
          selectGridRegion: '- Select Area -',
          gridRegions: {
            NO1: 'Østlandet NO1',
            NO2: 'Sørlandet NO2',
            NO3: 'Midt-Norge NO3',
            NO4: 'Nord-Norge NO4',
            NO5: 'Vestlandet NO5',
          },
        },
        publicDisplay: {
          title: 'Public Display',
          loginToDisplay: 'Login to Display',
          invalidPassword: 'Invalid password. Please try again.',
          password: 'Password',
          publicLink: 'Public Display Link:',
          description:
            'Display key building metrics on a public screen without any user interface',
          placeholder: 'Enter new password',
          leaveBlankHint: 'Leave blank to keep the current password.',
          copyButton: 'Copy',
          copySuccess: 'Link copied to clipboard',
          saveVendorFirst: 'Please save the vendor to generate a token',
          regenerateButton: 'Regenerate Token',
          regenerateWarning: 'Warning: This will invalidate the existing link',
          confirmRegenerate:
            'Are you sure you want to regenerate the token? This will invalidate the existing link.',
          tokenRegenerated: 'Token regenerated successfully',
          tokenRegenerateFailed: 'Failed to regenerate token',
        },
      },
      logo: {
        title: 'Logo',
      },
      privacy: {
        title: 'Privacy and Anonymizing',
        activateAnonymizing: 'Activate anonymizing',
        privacyPolicyText:
          'This is where you setup the interval for anonymizing',
        monthsToKeepData: 'Number of months to keep data',
      },
      keyAccountManager: {
        title: 'Key Account Manager',
        notAssigned: 'Not Assigned',
      },
      tenantStatus: {
        title: 'Tenant Status',
        tenantIsActive: 'Tenant is Active',
        status: 'Status',
        options: {
          development: '1. Development',
          readyForProduction: '2. Ready for production',
          production: '3. Production (system set)',
          deleted: 'Deleted',
        },
        markedForDeletion: 'Marked for deletion',
        vendorDeletionTitle: 'Vendor Deletion',
        vendorDeletionDescription:
          'The system will delete the vendor only if the vendor is marked for deletion, the tenant status is set to deleted, and the vendor is inactive. The vendor will be deleted if the model was last updated more than 30 days ago, ensuring that the vendor is not in use.',
      },
      vendorIdLabel: 'Vendor ID',
      successMessage: 'Vendor updated successfully',
      successMessagePassword: 'Vendor updated successfully (Password updated)',
      errorMessage: 'Failed to update vendor',
    },

    imageUpload: {
      uploadImage: 'Upload Image',
      noFileSelected: 'No file selected',
      uploading: 'Uploading...',
      fileSizeExceeded: 'File size exceeds {{size}}MB limit.',
      invalidFileType: 'Invalid file type. Please select an image.',
      uploadFailed: 'Upload failed. Please try again',
      bytes: 'bytes',
      dropToReplace: 'Drop image to replace',
      dragHint: 'Drag & drop here to replace',
      fromFileCloud: 'FileCloud',
      chooseFromFileCloud: 'Choose from FileCloud',
      convertingHeic: 'Converting HEIC image…',
      heicConversionFailed:
        'Could not convert HEIC image. Please try a JPEG or PNG instead.',
      uploadProgress: 'Uploading {{done}} of {{total}}…',
      uploadFailedFiles: 'Could not upload: {{names}}',
    },

    fileUpload: {
      uploadImage: 'Upload File',
      noFileSelected: 'No file selected',
      uploading: 'Uploading...',
      fileSizeExceeded: 'File size exceeds {{size}}MB limit.',
      invalidFileType: `Invalid file type. Please select a valid file.`,
      uploadFailed: 'Upload failed. Please try again',
      fileAlreadyUploaded: 'File is already uploaded',
      uploadFile: 'Upload File',
      viewUploadedFile: 'View Uploaded File',
      uploadNewFile: 'Upload New File',
      fileLabel: 'File:',
      sizeLabel: 'Size:',
    },

    fileCloud: {
      title: 'File Cloud',
      storageTitle: 'Storage',
      nameLabel: 'Name',
      folderLabel: 'Folder',
      sizeLabel: 'Size',
      dateLabel: 'Date Uploaded',
      buildingLabel: 'Building',
      currentPath: 'Current Path',
      rootLabel: 'Home',
      selectedLabel: 'selected',
      gridViewLabel: 'Grid view',
      listViewLabel: 'List view',
      header:
        'Securely store, organize and share files across your organization',
      uploadFiles: {
        dropZonePrompt: 'Drag and drop your file(s) here',
        selectedFilesHeader: 'Selected Files:',
        uploadButton: 'Upload',
        uploadFilesLabel: 'Upload Files',
        uploadFolderLabel: 'Upload Folder',
        uploadProgress: 'Uploading {{done}} of {{total}} files…',
      },
      noFiles: 'Drag and drop files',
      noBuildings: 'No buildings available.',
      menu: {
        download: 'Download',
        rename: 'Rename',
        delete: 'Delete',
        setBuilding: 'Set Building',
        clearBuilding: 'Clear Building',
      },
      dialog: {
        buildingTitle: 'Select Building',
        cancelButton: 'Cancel',
        newFolderName: 'Set Folder Name',
        createFolder: 'Create Folder',
        renameFolder: 'Rename Folder',
        confirmDeleteTitle: 'Confirm Delete',
        confirmDeleteMessage:
          'Are you sure you want to delete the selected file?',
        confirmFolderDeleteMessage:
          'Are you sure you want to delete the selected folder and all its contents?',
        invalidFolderName:
          'The folder name contains invalid characters or is empty.',
        duplicateFolderName: 'A folder with this name already exists.',
        confirmDeleteSelectedMessage:
          'Are you sure you want to delete the selected files?',
      },
      feedback: {
        // existing
        fileDeleted: 'File deleted successfully',
        buildingCleared: 'Building cleared successfully',
        buildingAssigned: 'Building assigned successfully',
        buildingUpdateError: 'Failed to update the building connection.',

        // Restore file
        fileRestored: 'File restored successfully.',
        restoreSuccessfulTitle: 'Restore Successful',
        restoreErrorMessage: 'Failed to restore file.',
        restoreErrorTitle: 'Restore Error',

        // Empty garbage
        garbageEmptied: 'Garbage emptied successfully.',
        emptyGarbageSuccessfulTitle: 'Empty Garbage Successful',
        emptyGarbageErrorMessage: 'Failed to empty garbage.',
        emptyGarbageErrorTitle: 'Empty Garbage Error',

        // Move folder to garbage
        folderMovedToGarbage: 'Folder moved to garbage successfully.',
        moveFolderToGarbageSuccessfulTitle: 'Move to Garbage Successful',
        moveFolderToGarbageErrorMessage: 'Failed to move folder to garbage.',
        moveFolderToGarbageErrorTitle: 'Move to Garbage Error',

        // Rename folder
        folderRenamed: 'Folder renamed successfully.',
        renameFolderSuccessfulTitle: 'Rename Successful',
        renameFolderErrorMessage: 'Failed to rename folder.',
        renameFolderErrorTitle: 'Rename Error',

        // Move folder
        folderMoved: 'Folder moved successfully.',
        moveFolderSuccessfulTitle: 'Move Successful',
        moveFolderErrorMessage: 'Failed to move folder.',
        moveFolderErrorTitle: 'Move Error',

        // Delete file (you already have the message, adding titles + error text)
        deleteSuccessfulTitle: 'Delete Successful',
        deleteErrorMessage: 'Failed to delete file.',
        deleteErrorTitle: 'Delete Error',

        // Move file (error only shown in your snippet)
        moveFileErrorMessage: 'Failed to move file.',
        moveFileErrorTitle: 'Move Error',

        // Create folder (error only shown in your snippet)
        createFolderErrorMessage: 'Failed to create folder.',
        createFolderErrorTitle: 'Create Folder Error',

        // Upload
        uploadSuccessfulMessage: 'Files uploaded successfully.',
        uploadSuccessfulTitle: 'Upload Successful',
        uploadErrorTitle: 'Upload Error',
      },
      newFolder: 'New Folder',
      confirmDeleteFolder:
        'Are you sure you want to delete this folder and all its contents?',
      moveToRoot: 'Move to Root Directory',
    },

    aspaSetup: {
      list: {
        header: 'ASPA Setup',
        addButton: 'Add ASPA Setup',
        emptyState: 'No ASPA setups found.',
        searchPlaceholder: 'Search...',
      },
      edit: {
        name: 'ASPA Setup Name',
        units: 'Units',
        addUnit: 'Add Unit',
        unitName: 'Unit Name',
        setpoints: 'Setpoints',
        zones: 'Zones',
        removeUnit: 'Remove Unit',
        copyMondayToWeekdays: 'Copy Monday to Weekdays',
        copyMondayToAllDays: 'Copy Monday to All Days',
      },
      feedback: {
        deleteSuccess: 'ASPA setup successfully deleted',
        deleteError: 'An error occurred while trying to delete the ASPA setup',
        updateSuccess: 'ASPA setup successfully updated',
        updateError: 'An error occurred while trying to update the ASPA setup',
        createSuccess: 'ASPA setup successfully created',
        createError: 'An error occurred while trying to create the ASPA setup',
        saveError: 'An error occurred while trying to save the ASPA setup',
      },
    },

    energyPrices: {
      list: {
        add: 'Add energy price',
        header: 'Energy price settings',
        emptyState: 'No energy price settings found.',
        searchPlaceholder: 'Search energy price settings...',
      },

      name: 'Name',
      notes: 'Notes',
      building: 'Building',
      selectBuilding: 'Select building',
      validFrom: 'Valid from',
      validTo: 'Valid to',
      ongoing: 'Ongoing',
      notSpecified: 'Not specified',

      electricityDetails: 'Electricity details',
      priceModel: 'Pricing model',
      fixed: 'Fixed price',
      spotMarkup: 'Spot + markup',
      fixedPricePerKWh: 'Fixed price per kWh',
      spotMarkupPerKWh: 'Markup per kWh',

      supplierMonthlyFee: 'Supplier monthly fee',
      co2Emissions: 'CO₂ emissions (gCO₂/kWh)',

      gridTariffs: 'Grid charges',
      gridTariff: 'Grid charge',
      fixedMonthly: 'Fixed monthly fee',
      energyPerKWh: 'Energy per kWh',
      demandPerKWMonthly: 'Demand charge per kW per month',
      consumptionTaxPerKWh: 'Consumption tax per kWh',

      energySources: 'Energy sources',
      addEnergySources: 'Add energy sources',
      energySource: 'Energy source information',
      sourceName: 'Source name',
      electricity: 'Delivered electricity',
      electricityPrice: 'Electricity price',
      electricityProduced: 'Produced electricity',
      electricityExported: 'Exported electricity',

      districtHeating: 'District heating',
      districtHeatingSource: 'District heating energy source',
      districtHeatingPrice: 'District heating price',
      districtHeatingEnergyPrice: 'Energy price (kr/kWh)',
      districtHeatingDemandPerKWMonthly:
        'Highest measured demand (kr/kW/month)',

      fuelSources: 'Fuel sources',
      fuelSource: 'Fuel source information',
      fuelType: 'Energy source',

      propane: 'Propane',
      fuelOilDiesel: 'Fuel oil / Diesel',
      lng: 'Natural gas (LNG)',
      kerosene: 'Kerosene',
      pelletsBricks: 'Pellets / Briquettes',
      biodiesel: 'Biodiesel',
      biogas: 'Biogas',
      other: 'Other',

      consumptionUnit: 'Consumption unit',
      kg: 'kg',
      liter: 'liter',
      unitPrice: 'Unit price',
      consumption: 'Consumption',
      conversionFactorToKWh: 'Conversion factor to kWh',

      periodLabel: 'Period',
      periodLabelPlural: 'Periods',
      periodName: 'Period name',
      addPeriod: 'Add period',
      removePeriod: 'Remove period',
      removePeriodConfirmation: 'Are you sure you want to remove this period?',
      noPeriodsDefined: 'No periods.',
      overlappingPeriodsError:
        'Periods "{p1}" and "{p2}" overlap.\n\n' +
        'You cannot have two periods that apply simultaneously (same months and overlapping times). ' +
        'Adjust months or active hours before saving.',
      mixedMonthsError:
        'You cannot mix specific months with "all months" (empty months) across periods.\n\n' +
        'These periods must select months: {periods}\n\n' +
        'Tip: Either select months for all periods, or leave months empty for all periods.',
      confirmRemovePeriod: 'Are you sure you want to remove the period?',
      generalInformation: 'General information',
      activeMonths: 'Active months (All if empty)',
      activeBetween: 'Active between (All if empty)',
      chosenMonths: 'Active months',
      activeHours: 'Active hours',
      allYear: 'All year',
      allDay: 'All day',
      addAdditionalTimer: 'Add additional timer',
      startTime: 'Start time',
      endTime: 'End time',
      timeRangeInvalid: 'End time must be after start time',
      timeRangesOverlap: 'Time ranges cannot overlap',
      timeRangeEqual: 'Start and end time cannot be the same',

      co2Source: 'District heating energy type',
      co2Array: [
        'Electricity',
        'Waste',
        'Light fuel oil',
        'Heavy fuel oil',
        'Liquefied petroleum gas',
        'Natural gas (LNG)',
        'Primary wood biofuel',
        'Secondary wood biofuel',
        'RT chips',
        'Pellets, briquettes and powder',
        'Bio oil',
        'Heat pump',
      ],

      fixedFees: 'Fixed fees',
      substationFee: 'Substation fee (per month)',
      reactiveEffect: 'Reactive power charge',

      connectedDevices: 'Connected devices',
      noConnectedDevices: 'No connected devices',
      deletedDevice: 'Deleted',
      removeSource: 'Remove source',
      noLinkedDevices: 'No linked devices',
      linked: 'Linked devices',
      unlinkDeviceMessage: 'Are you sure you want to remove this device?',
      linkSourceTitle: 'Link energy source to EOS device',
      linkSource: 'Link energy source to EOS devices',
      linkSourceDescription:
        'Select which EOS devices are linked to this energy source.',

      removeElectricitySourceConfirmation:
        'Are you sure you want to remove the electricity source ',
      removeDistrictHeatingSourceConfirmation:
        'Are you sure you want to remove the district heating source ',
      removeFuelSourceConfirmation:
        'Are you sure you want to remove the fuel source ',
    },

    setpoint: {
      title: 'Setpoints',
      backToList: 'All setpoints',
      description:
        'Temperature, humidity and CO₂ limits per building and zone.',
      searchPlaceholder: 'Search setpoints …',
      emptyState: 'No setpoints yet.',
      addButton: 'New setpoint',
      loadError: 'Could not load the setpoints.',
      zonesLoadError: 'Could not load the zones.',
      saveError: 'Could not save the setpoint.',
      deleteError: 'Could not delete the setpoint.',
      requiredError: 'These fields are required:',
      deleteConfirmTitle: 'Delete setpoint',
      deleteConfirmMessage:
        'Are you sure you want to delete this setpoint? This cannot be undone.',
      editTitle: 'Edit setpoint',
      newTitle: 'New setpoint',
      editDescription: 'The limits apply to the zones you select.',
      saveButton: 'Save setpoint',
      openSetpoint: 'Open the setpoint',
      buildingSection: 'Building',
      building: 'Building',
      name: 'Name',
      namePlaceholder: 'E.g. Office standard',
      zonesSection: 'Zones',
      selectAll: 'Select all',
      clearAll: 'Clear all',
      noZones: 'Pick a building to see its zones.',
      allZonesTaken: 'Every zone in this building already has a setpoint.',
      zonesTakenError: 'One or more zones already belong to another setpoint.',
      noZonesSelected: 'No zones selected',
      floor: 'Floor',
      noFloor: '—',
      limitsSection: 'Limits',
      columns: {
        name: 'Name',
        building: 'Building',
        zones: 'Zones',
        inOperation: 'In operation',
        outsideOperation: 'Outside operation',
        interval: 'Check interval',
      },
    },
    operatingCalendar: {
      backToList: 'All operating calendars',
      title: 'Operating calendars',
      description:
        'Normal operating hours per building and zone, with extraordinary operation on top.',
      searchPlaceholder: 'Search operating calendars …',
      emptyState: 'No operating calendars yet.',
      addButton: 'New operating calendar',
      running: 'Running, no end date',
      openCalendar: 'Open the calendar',
      zonesLoadError: 'Could not load the zones.',
      loadError: 'Could not load the operating calendars.',
      saveError: 'Could not save the operating calendar.',
      deleteError: 'Could not delete the operating calendar.',
      requiredError: 'These fields are required:',
      deleteConfirmTitle: 'Delete operating calendar',
      deleteConfirmMessage:
        'Are you sure you want to delete this operating calendar? This cannot be undone.',
      editTitle: 'Set normal operation',
      editDescription: 'Fixed weekly operating hours for the selected zones.',
      saveButton: 'Save normal operation',
      buildingSection: 'Building',
      building: 'Building',
      zonesSection: 'Zones',
      selectAll: 'Select all',
      clearAll: 'Clear all',
      noZonesSelected: 'No zones selected',
      zonesTakenError:
        'One or more zones already belong to another operating calendar.',
      allZonesTaken:
        'Every zone in this building already belongs to a calendar.',
      noZones: 'Pick a building to see its zones.',
      floor: 'Floor',
      noFloor: 'No floor',
      validitySection: 'Name and validity',
      name: 'Name',
      validFrom: 'Valid from',
      validTo: 'Valid to',
      weekPlanSection: 'Week plan',
      copyMonday: 'Copy Monday to all weekdays',
      noOperation: 'No operation',
      weeklyTotal: 'Total per week',
      from: 'From',
      to: 'To',
      calendarTitle: 'Operating calendar',
      week: 'Week',
      previousWeek: 'Previous week',
      nextWeek: 'Next week',
      today: 'Today',
      editNormal: 'Normal operation',
      addOverride: 'Add extraordinary operation',
      thisWeek: 'This week',
      operatingHours: 'Operating hours',
      extraordinaryDays: 'Extraordinary days',
      upcomingOverrides: 'Upcoming extraordinary operation',
      noOverrides: 'Nothing planned.',
      fixedOperation: 'Fixed operation',
      publicHoliday: 'Public holiday',
      extraordinary: 'Extraordinary operation',
      closed: 'Closed',
      opensAt: 'Opens',
      closesAt: 'Closes',
      inOperation: 'In operation',
      outOfOperation: 'Out of operation',
      allDay: 'All day',
      reason: 'Reason',
      overrideSaveError: 'Could not save the extraordinary operation.',
      overrideDeleteError: 'Could not delete it.',
      columns: {
        name: 'Name',
        building: 'Building',
        zones: 'Zones',
        validity: 'Validity',
        hoursPerWeek: 'Hours/week',
      },
      weekdays: {
        mon: 'Mon',
        tue: 'Tue',
        wed: 'Wed',
        thu: 'Thu',
        fri: 'Fri',
        sat: 'Sat',
        sun: 'Sun',
      },
    },
    controlStrategy: {
      list: {
        header: 'Control Strategies',
        addButton: 'Add Control Strategy',
        emptyState: 'No control strategies found.',
        searchPlaceholder: 'Search by building...',
      },
      feedback: {
        saveSuccess: 'Control strategy saved successfully',
        saveError: 'An error occurred while saving the control strategy',
        buildingRequired: 'Building is required',
        bothHoursRequired: 'Both start and end hour must be set',
        startBeforeEnd: 'Start hour must be before end hour',
        deleteSuccess: 'Control strategy deleted successfully',
        deleteError: 'An error occurred while deleting the control strategy',
        confirmDeleteTitle: 'Delete control strategy',
        confirmDeleteMessage:
          'Are you sure you want to delete this control strategy? This cannot be undone.',
      },
      schedule: 'Operating hours',
      timezone: 'Timezone',
      startHour: 'Operating hours start',
      endHour: 'Operating hours end',
      actions: 'Actions',
      coolingLevel: 'Cooling level',
      heatingLevel: 'Heating level',
      businessHoursControl: 'Business hours control',
      afterHoursControl: 'After hours control',
      controlOutsideBusinessHours: 'Control outside business hours',
      tempMin: 'Temp min (°C)',
      tempMax: 'Temp max (°C)',
      co2Min: 'CO₂ min (ppm)',
      co2Max: 'CO₂ max (ppm)',
      actionLabels: {
        cool: 'Cool',
        heat: 'Heat',
        preCool: 'Pre-cool',
        preHeat: 'Pre-heat',
        ventilate: 'Ventilate',
        dehumidify: 'Dehumidify',
      },
      closed: 'Closed',
      afterHoursActions: 'After-hours actions',
    },

    baseline: {
      updated: 'Updated',
      title: 'Baseline',
      searchPlaceholder: 'Search for baseline...',
      addButtonLabel: 'Create new baseline',
      confirmDeleteTitle: 'Delete baseline',
      confirmDeleteMessage: 'Are you sure you want to delete this baseline?',
      noBaselines: 'No baselines found. Create a new baseline.',
      createNewBaselineConfirm:
        'Create new baseline? This will overwrite the existing one.',
      editBaseline: 'Edit Baseline for',
      calculateBaseline: 'Calculate Baseline',
      baselineChart: 'Baseline Chart',
      monthsCovered: 'Months covered',
      excludeMonths: 'Exclude months',
      pendingChanges: 'Unsaved changes. Click Save to update the baseline.',
      clickMonthsToExclude: `Click months to exclude them from the baseline. Orange months has 20% or more deviation from the baseline.`,
      year: 'Year',
      month: 'Month',
      energyType: 'Energy type',
      monthlySummary: 'Monthly summary',
      weeklySummary: 'Weekly summary',
      week: 'Week',
      summary: 'Summary',
      excluded: 'Excluded from baseline',
      energyTypes: {
        electricity: 'Electricity',
        districtHeating: 'District heating',
        fuel: 'Fuel',
      },
      overBaseline: 'Over baseline',
      underBaseline: 'Under baseline',
      included: 'Included in baseline',
      activeLabel: 'Active',
      inactiveLabel: 'Inactive',
      createdAt: 'Created',
      lockTooltip: {
        locked: 'Locked — click to allow edits',
        unlocked: 'Lock to block edits',
      },
      description: 'Create and configure baselines',
      backButtonLabel: 'Back to baselines',
    },

    feedback: {
      vendorLoad: {
        title: 'Error',
        message: 'Unable to load vendor information',
      },
    },
    degreeDays: {
      error: 'Building is missing GPS coordinates',
    },
  },
  feedback: {
    open: 'Feedback',
    title: 'Send Feedback',
    close: 'Close',
    messageLabel: 'Message',
    placeholder: 'Enter your feedback here…',
    screenshotTitle: 'Upload Image',
    send: 'Send',
    infoPrefix: 'For more information see our',
    helpCenter: 'Help Center',
    statusPage: 'Status Page',
  },
  helpCenter: {
    backToOverview: '← Back to Overview',
    menu: {
      overview: 'Overview',
      building: 'Building',
      devices: 'Devices',
      settings: 'Settings',
      map: 'Map',
    },
    heroTitle: 'Support - Sastech Dashboard',
    faqTitle: 'Frequently Asked Questions',
    faq: {
      getStarted: {
        question: 'How do I get started?',
        answer:
          'To get started, simply log in to your Sastech Dashboard account. If you do not have an account yet, please contact our support or sales team for assistance. Once logged in, you can access various features and tools to manage your Energy Management System.',
      },
      resetPassword: {
        question: 'How do I reset my password?',
        answer:
          'If you have forgotten your password, click on the Forgot Password? link on the login page. Follow the instructions to reset your password via email. If you encounter any issues, please contact our support team for assistance.',
      },
      contactSupport: {
        question: 'How do I contact support?',
        answer:
          'You can either send an email to our support team at support@sastech.no or use the contact form available on our website. Our support team is available Monday to Friday, 8 AM to 4 PM (Europe/Oslo). We strive to respond to all inquiries within 12 hours on business days.',
      },
      visualGuide: {
        question: 'Dashboard Visual Guide',
        answer: 'Want to understand each section of the dashboard? ',
        linkText: 'EOS Dashboard Guide',
      },
    },
    contact: {
      heading: 'Contact Us',
      intro:
        'If you have any questions or need further assistance, please fill out the form below:',
      labels: {
        name: 'Name:',
        email: 'Email:',
        message: 'Message:',
      },
      submit: 'Submit',
      terms:
        'By submitting this form, you agree to our terms and conditions and privacy policy. We will use your information to respond to your inquiry and provide you with the best possible support.',
    },
    thankYou: {
      heading: 'Thank You!',
      lines: [
        'Your message has been sent successfully.',
        'We will get back to you as soon as possible.',
      ],
    },
  },
  admin: {
    buildingInspection: BUILDING_INSPECTION,
    energyLabelLeads: ENERGY_LABEL_LEADS,
    siteInspection: {
      deleteNoSiteInspectionsMessage:
        'No site inspection selected for deletion.',
      deleteConfirmMessage:
        'Are you sure you want to delete this site inspection? This action cannot be undone.',
      deleteSuccessMessage: 'Site inspection deleted successfully.',
      deleteErrorMessage: 'Failed to delete site inspection.',
      updateSuccessMessage: 'Site inspection updated successfully.',
      createSuccessMessage: 'Site inspection created successfully.',
      failedToLoadMessage:
        'Failed to load site inspections. Please try again later.',
      saveErrorMessage:
        'Failed to save site inspection. Please try again later.',
      buildingErrorMessage: 'Please select a building for the site inspection.',
      buildingTypeErrorMessage:
        'Please select a building type for the site inspection.',
      failedToLoadBuildingsMessage:
        'Failed to load buildings. Please try again later.',
      calculationsCompleteMessage: 'Calculations complete',
      fetchError: 'Failed to fetch buildings.',
      fetchErrorById: 'Failed to fetch site inspection.',
      confirmDeletion: {
        title: 'Confirm Deletion',
        hvacUnit: 'HVAC Unit',
        heatingCoolingModule: 'Heating/Cooling Module',
        productionEquipment: 'Production Equipment',
        zone: 'Zone',
        excessEnergyModule: 'Excess Energy Module',
        confirmMessage: 'Are you sure you want to delete',
      },
      attachments: {
        addImage: 'Add Image',
      },
      //Header
      title: 'Site Inspection',
      subtitle: 'Complete your inspection with the guided form below',
      newInspectionLabel:
        'Please select building and building type to continue.',
      reportLabel: 'Report',
      actionsLabel: 'Actions',
      generalLabel: 'General',
      //Info
      status: {
        statusLabel: 'Status',
        draft: 'Draft',
        completed: 'Completed',
        inReview: 'In Review',
      },
      buildingLabel: 'Building',
      buildingTypeLabel: 'Building Type (NS Standard)',
      notesLabel: 'Notes',
      buildingTypes: {
        label: {
          smallHouse: 'Small House',
          apartmentBlock: 'Apartment Block',
          kinderGarden: 'Kindergarden',
          officeBuilding: 'Office Building',
          schoolBuilding: 'School Building',
          universityCollege: 'University / College',
          hospital: 'Hospital',
          nursingHome: 'Nursing Home',
          hotel: 'Hotel',
          sportsBuilding: 'Sports Building',
          commercialBuilding: 'Commercial Building',
          culturalBuilding: 'Cultural Building',
          lightIndustryWarehouse: 'Light Industry / Warehouse',
        },
        description: {
          smallHouse:
            'Single-family house, semi-detached, terraced house, chain house, or other small residential buildings.',
          apartmentBlock:
            'Residential block with two or more floors, including large terraced houses with multiple floors.',
          kinderGarden:
            'Buildings designed for kindergarten or early childhood education.',
          officeBuilding:
            'Simple offices, offices with ventilation and cooling, or exhibition/congress buildings.',
          schoolBuilding:
            'Teaching premises, including schools with swimming pools or sports halls.',
          universityCollege:
            'University or college buildings, laboratory buildings, or research facilities.',
          hospital:
            'Hospitals, hospital hotels, or laboratory buildings for medical use.',
          nursingHome: 'Nursing home buildings for long-term residential care.',
          hotel:
            'Hotels, restaurant buildings, or other buildings for accommodation.',
          sportsBuilding:
            'Sports halls, swimming pools, and other athletic facilities with shower areas.',
          commercialBuilding:
            'Shops, stores with cold/freezer rooms, or petrol stations.',
          culturalBuilding:
            'Cinemas, museums, libraries, and religious buildings.',
          lightIndustryWarehouse:
            'Industrial buildings, warehouses, fishery/agricultural buildings, energy supply facilities, or other workshops.',
        },
      },
      mainTabs: {
        info: 'Info',
        climate: 'Climate',
        zones: 'Zones',
        hvac: 'HVAC & Operations',
        heatingCooling: 'Heating & Cooling',
        excessEnergy: 'Excess Energy',
        analytics: 'Analytics',
        attachments: 'Attachments',
      },
      footerButtons: {
        next: 'Next',
        previous: 'Previous',
      },
      climate: {
        averageMonthlyTemp: 'Average Monthly Temperature (°C)',
        globalIrradiation: 'Global Irradiation (kWh/m²)',
        diffuseIrradiation: 'Diffuse Irradiation (kWh/m²)',
        albedo: 'Albedo (0-1)',
      },
      hvacTabs: {
        hvacUnits: 'HVAC Units',
        operationalLoads: 'Operational Loads',
        productionEquipment: 'Production Equipment',
      },
      zoneManager: {
        area: 'Area (m²)',
        noZonesCreatedYet: 'No zones created yet',
        createZoneToBegin:
          'Create a zone to begin collecting building envelope data. You can either select an existing building zone or create a new one specifically for this site inspection.',
        subTabs: {
          buildingEnvelope: 'Building Envelope',
          windows: 'Windows',
          doors: 'Doors',
          gates: 'Gates',
          airLeakage: 'Air Leakage',
          thermalMass: 'Thermal Mass',
        },
        zoneSelector: {
          createFirstZone: 'Create Zone',
          addZone: 'Add Zone',
          deleteSelectedZone: 'Delete Selected Zone',
          linked: 'Linked',
          editZoneName: 'Edit zone name',
          editZoneNameTitle: 'Edit zone name',
          zoneNameLabel: 'Zone name',
          cancelButton: 'Cancel',
          saveButton: 'Save',
          updateError: 'Failed to update zone name',
          updateSuccess: 'Zone name updated',
        },
        zoneCreateModal: {
          zoneNameError: 'Zone name is required.',
          createNewZoneLabel: 'Create New Zone',
          linkExistingZoneLabel: 'Link Existing Zone',
          linkExistingZoneHelperText:
            'Select an existing zone to link to this site inspection.',
          selectZonePlaceholder: 'Select a zone...',
          createNewZoneHelperText:
            'Create a new zone that will be added to the building and used for this site inspection.',
          zoneName: 'Zone Name',
          description: 'Description',
          cancelButtonLabel: 'Cancel',
          addZoneTitle: 'Add Zone',
          zoneNameLabel: 'Zone Name',
          descriptionLabel: 'Description',
        },
        exteriorWalls: 'Exterior Walls',
        helperWithHistory: {
          north: 'North',
          south: 'South',
          east: 'East',
          west: 'West',
          count: 'Count',
          width: 'Width (m)',
          height: 'Height (m)',
          addToArea: 'Add to Area (m²)',
          history: 'History',
          entry: 'Entry',
          entries: 'Entries',
          inputHistory: 'Input History',
          helperTitle: 'Area Calculator',
        },
        buildingEnvelope: {
          bra: 'Heated usable area (m²)',
          floors: 'Number of Floors',
          floorHeight: 'Floor Height (m)',
          indoorTemperature: 'Indoor Temperature (°C)',
          heatedVolume: 'Heated Air Volume (m³)',
          thermalBridge: 'Thermal Bridge',
          totalExternalWallArea: 'Total External Wall Area',
          groundConditions: {
            title: 'Ground Conditions',
            options: {
              none: 'None',
              clay: 'Clay',
              drySandGravel: 'Sand/Gravel (Dry)',
              moistSandGravel: 'Sand/Gravel (Moist)',
              wetSandGravel: 'Sand/Gravel (Wet)',
              rock: 'Rock',
              moraine: 'Moraine',
              dryPeat: 'Peat (Dry)',
              moistPeat: 'Peat (Moist)',
              wetPeat: 'Peat (Wet)',
              silt: 'Silt',
              organicSoil: 'Organic Soil',
            },
            heatCapacity: 'Heat Capacity (J/m²K)',
            thermalConductivity: 'Thermal Conductivity (W/mK)',
            groundTemperature: 'Ground Temperature (°C)',
          },
          grossArea: 'Gross Area (m²)',
          netArea: 'Net Area (m²)',
          netAreaFormula: 'Gross wall - Windows - Doors - Gates',
          wallConstruction: {
            title: 'Wall Construction',
            // We are going to change wall construction type so translations will come later here
          },
          uValue: 'U-Value (W/m²K)',
          shadingFactor: 'Shading Factor',
          area: 'Area (m²)',
          yearInstalled: 'Year Installed',
          yearInstalledNone: 'None',
          yearInstalledBefore1949: 'Before 1949',
          yearInstalledFrom1997: 'From 1997 onwards',
          floor: {
            area: 'Floor Area (m²)',
            uValue: 'Floor U-Value (W/m²K)',
            title: 'Floor',
            options: {
              title: 'Type of Floor Material',
              standard: 'Standard',
              tiles: 'Tiles (7 mm) + Concrete',
              flooringChipBoard: 'Flooring (4 mm) + 22 mm chipboard',
              flooringConcrete: 'Flooring (4 mm) + Concrete',
              flooringLWA: 'Flooring (4 mm) + Lightweight aggregate',
              parquetChipBoard: 'Parquet (14 mm) + 22 mm chipboard',
              parquetConcrete: 'Parquet (14 mm) + Concrete',
              parquetLWA: 'Parquet (14 mm) + Lightweight aggregate',
              carpetChipBoard: 'Carpet (10 mm) + 22 mm chipboard',
              carpetConcrete: 'Carpet (10 mm) + Concrete',
              carpetLWA: 'Carpet (10 mm) + Lightweight aggregate',
            },
          },
          roof: {
            title: 'Roof',
            optionsTitle: 'Roof Construction',
            area: 'Roof Area (m²)',
            uValue: 'Roof U-Value (W/m²K)',
            options: [
              'Standard',
              'Compact roof with 200–250 mm concrete slab, 200 mm insulation',
              'Compact roof with 200–250 mm concrete slab, 250 mm insulation',
              'Compact roof with 200–250 mm concrete slab, 300 mm insulation',
              'Compact roof with 200–250 mm concrete slab, 350 mm insulation',
              'Compact roof with 200–250 mm concrete slab, 400 mm insulation',
              'Compact roof with 200–250 mm concrete slab, 450 mm insulation',
              'Compact roof with 200–250 mm concrete slab, 500 mm insulation',
              'Compact roof with corrugated steel deck, 200 mm insulation',
              'Compact roof with corrugated steel deck, 250 mm insulation',
              'Compact roof with corrugated steel deck, 300 mm insulation',
              'Compact roof with corrugated steel deck, 350 mm insulation',
              'Compact roof with corrugated steel deck, 400 mm insulation',
              'Compact roof with corrugated steel deck, 450 mm insulation',
              'Compact roof with corrugated steel deck, 500 mm insulation',
              'Pitched roof with 48 mm timber rafters (9% area fraction), 200 mm insulation',
              'Pitched roof with 48 mm timber rafters (9% area fraction), 250 mm insulation',
              'Pitched roof with 48 mm timber rafters (9% area fraction), 300 mm insulation',
              'Pitched roof with 48 mm timber rafters (9% area fraction), 350 mm insulation',
              'Pitched roof with 48 mm timber rafters (9% area fraction), 400 mm insulation',
              'Pitched roof with I-joists (6% area fraction), 200 mm insulation',
              'Pitched roof with I-joists (6% area fraction), 250 mm insulation',
              'Pitched roof with I-joists (6% area fraction), 300 mm insulation',
              'Pitched roof with I-joists (6% area fraction), 350 mm insulation',
              'Pitched roof with I-joists (6% area fraction), 400 mm insulation',
              'Pitched roof with I-joists (6% area fraction), 450 mm insulation',
              'Pitched roof with I-joists (6% area fraction), 500 mm insulation',
              'Pitched roof with I-joists (6% area fraction), 550 mm insulation',
              'Cold roof with 48 mm joists (9% area fraction), 200 mm insulation',
              'Cold roof with 48 mm joists (9% area fraction), 250 mm insulation',
              'Cold roof with 48 mm joists (9% area fraction), 300 mm insulation',
              'Cold roof with 48 mm joists (9% area fraction), 350 mm insulation',
              'Cold roof with 48 mm joists (9% area fraction), 400 mm insulation',
              'Cold roof with 48 mm joists (9% area fraction), 450 mm insulation',
              'Cold roof with 48 mm joists (9% area fraction), 500 mm insulation',
              'Cold roof with 48 mm joists (9% area fraction), 550 mm insulation',
            ],
          },
          basement: {
            title: 'Basement',
            area: 'Basement Area (m²)',
            wallHeight: 'Wall height (m)',
            wallThickness: 'Wall thickness (m)',
            baseWallConstruction: 'Wall construction',
            wallUValue: 'U-value (W/m²K)',
            heatStorage: 'Heat Storage type',
            effectiveHeatCapacity: 'Effective heat capacity (kJ/m²K)',
            floorConstruction: 'Floor construction',
            baseWallConstructionType: 'Wall construction type',
            baseWallConstructionOptions: [
              'Standard',
              '200 mm concrete with 100 mm insulation',
              '200 mm concrete with 150 mm insulation',
              '200 mm concrete with 200 mm insulation',
              '200 mm concrete with 250 mm insulation',
              '200 mm concrete with 300 mm insulation',
              '300 mm concrete with 100 mm insulation',
              '300 mm concrete with 150 mm insulation',
              '300 mm concrete with 200 mm insulation',
              '300 mm concrete with 250 mm insulation',
              '300 mm concrete with 300 mm insulation',
            ],

            heatStorageTypes: [
              'None',
              'Light (< 50 Wh/m²K)',
              'Medium (50–100 Wh/m²K)',
              'Heavy (100–150 Wh/m²K)',
              'Very heavy (> 150 Wh/m²K)',
              '100 mm concrete',
              '150 mm concrete',
              '200 mm concrete',
              '250 mm concrete',
              '300 mm concrete',
              'Timber',
              'Gypsum board',
            ],

            floorConstructionTypes: [
              'None',
              'Standard',
              'Concrete slab on ground with 100 mm insulation',
              'Concrete slab on ground with 150 mm insulation',
              'Concrete slab on ground with 200 mm insulation',
              'Concrete slab on ground with 250 mm insulation',
              'Concrete slab on ground with 300 mm insulation',
              'Concrete slab on ground with 350 mm insulation',
              'Concrete slab on ground with 400 mm insulation',
              'Timber joist floor with 200 mm insulation',
              'Timber joist floor with 250 mm insulation',
              'Timber joist floor with 300 mm insulation',
            ],
          },
        },
        doors: {
          title: 'Door type',
          yearInstalled: 'Year installed',
          totalArea: 'Total door area',
          totalAreaFormula: 'Sum of all door surfaces',
          avgUValue: 'Average U-value (doors)',
          avgUValueFormula: '(Σ(U × area)) / Σ(area)',
          percentageOfFacade: 'Door area as % of façade',
          percentageOfFacadeFormula:
            'Total door area / Total façade area × 100',
          doorTypes: [
            'None',
            'Standard',
            'Insulated',
            'Normal',
            'Well insulated',
            'Uninsulated',
          ],
        },

        gates: {
          title: 'Gate type',
          yearInstalled: 'Year installed',
          totalArea: 'Total gate area',
          totalAreaFormula: 'Sum of all gate surfaces',
          avgUValue: 'Average U-value (gates)',
          avgUValueFormula: '(Σ(U × area)) / Σ(area)',
          percentageOfFacade: 'Gate area as % of façade',
          percentageOfFacadeFormula:
            'Total gate area / Total façade area × 100',
        },

        airLeakage: {
          airLeakageRate: 'Air leakage (l/s·m² at 50 Pa)',
          airChangeRate: 'Air change rate (ACH at 50 Pa)',
          naturalVentilation: 'Natural ventilation',
        },

        thermalMass: {
          buildingHeatCapacity: 'Heat Capacity of Entire Building',
          heatCapacitySelectTitle: 'Building type (NS 3031 B.2.8)',
          shortDescriptionFirstOption:
            'Light joist floor, thin floor covering, lightweight walls',
          shortDescriptionSecondOption:
            'Acoustic ceiling, carpet on concrete, lightweight walls',
          shortDescriptionThirdOption:
            'Limited exposed concrete (20%), parquet on concrete',
          shortDescriptionFourthOption: 'Mainly exposed concrete (70%)',
          shortDescriptionFifthOption:
            'Exposed concrete in ceiling, walls, and floor',

          labelFirstOption: 'Very light building',
          labelSecondOption: 'Light building',
          labelThirdOption: 'Medium building',
          labelFourthOption: 'Heavy building',
          labelFifthOption: 'Very heavy building',

          normalizedHeatCapacity: 'Normalized heat capacity [Wh/(m²·K)]',
          normalizedHeatCapacityHelper: 'From NS 3031 Table B.8',

          interiorWalls: 'Interior walls',
          north: 'North',
          south: 'South',
          east: 'East',
          west: 'West',
          claddingTitle: 'Cladding',
          cladding: [
            'Custom',
            'Standard',
            '100 mm (or more) concrete',
            '80 mm concrete',
            'Aerated concrete',
            '13 mm gypsum board',
            'Light brick',
            'Lightweight clinker',
            'Solid wood (thickness over 40 mm)',
            '15 mm wood panel',
            'Heavy (solid) brick',
          ],
          claddingSubText: 'User-defined',
          internalConstruction: 'Internal construction',
          heatCapacity: 'Heat capacity [Wh/m²K]',
          grade: 'Grade',
          furniture: {
            title: 'Furniture',
            options: ['None', 'Standard', 'Light', 'Medium', 'Heavy'],
          },
          thermalHeatCapacityLabel: 'Thermal heat capacity',
          thermalHeatCapacityFormula:
            'BRA × norm value / 1000 (Norm: None = 0, Light = 40, Medium = 60, Heavy = 80 Wh/m²K)',
          floorSeparationsAreaLabel: 'Floor separation area (m²)',
          internalFloorsTooltip:
            'Internal floors between levels: BRA × (number of floors − 1) / number of floors',
        },
      },
    },
    siteInspectionActions: {
      enabled: 'Enabled',
      ventilation: {
        title: 'Ventilation Actions',
        actionIdError: 'Action ID not found',
        noUnitsError: 'Please enable at least one HVAC unit to simulate',
        nsEnergy: 'nsEnergy',
        ns: 'ns',
        failedToRunSimulation: 'Failed to run simulation',
        enabledLabel: 'Enabled',
        usingUnitBasedCalculator: 'Using unit-based calculator with ',
        enabledVentilationUnits:
          ' enabled ventilation unit(s) from Site Inspection.',
        areaLabel: 'Area (m²)',
        pricePerKwhLabel: 'Price per kWh (NOK)',
        co2PerKwhLabel: 'CO2 per kWh (g)',
        unitTitle: 'Ventilation Units',
        airFlow: 'Air Flow',
        ns3031A6: 'NS 3031 A.6',
        ns3031B1: 'NS 3031 B.1 (Recommended)',
        ns3031B2: 'NS 3031 B.2 (Recommended)',
        custom: 'Custom',
        operating: 'Operating',
        nonOperating: 'Non-operating',
        operatingTime: 'Operating Time',
        ns3031A3: 'NS3031 A.3 (Recommended)',
        sfpLabel: 'SFP (Specific Fan Power)',
        operatingSFP: 'Operating SFP',
        nonOperatingSFP: 'Non-Operating SFP',
        newOperatingAirFlow: 'New operating air flow [m³/(h·m²)]',
        newNonOperatingAirFlow: 'New non-operating air flow [m³/(h·m²)]',
        newHoursPerWeek: 'New hours/week',
        newWeeksPerYear: 'New weeks/year',
        newOperatingSfp: 'New operating SFP',
        newNonOperatingSfp: 'New non-operating SFP',
        unitConfig: {
          results: 'Results',
          energy: 'Energy',
          costNOK: 'Cost: NOK',
          year: 'year',
          CO2: 'CO₂',
          kgYear: 'kg/year',
          cumulativeSavingsOverTime: 'Cumulative Savings Over Time',
          simpleInstallationCost: 'Simple installation cost [NOK]',
          simpleInstallationCount: 'Simple installation count',
          complexInstallationCost: 'Complex installation cost per m² [NOK/m²]',
          complexInstallationCount: 'Complex installation count',
          coverageAreaLabel: 'Coverage Area [m²]',
          beforeExistingSystem: 'Before - Existing System',
          flowOperating: 'Flow Operating [m³/h]',
          flowNonOperating: 'Flow Non-Operating [m³/h]',
          hoursPerWeek: 'Hours/week',
          weeksPerYear: 'Weeks/year',
          hoursPerYear: 'Hours/year',
          operatingSfp: 'Operating SFP [kW/(m³/h)]',
          nonOperatingSfp: 'Non-Operating SFP [kW/(m³/h)]',
          heatRecoveryType: 'Heat Recovery Type',
          heatRecoveryEfficiency: 'Heat Recovery Efficiency [%]',
          afterSystem: 'After - New System',
          investment: 'Investment',
          totalInvestment: 'Total Investment',
          installationType: 'Installation Type',
          simple: 'Simple',
          complex: 'Complex',
          installationCost: 'Installation Cost [NOK]',
          runBuildingSimulation: 'Run Building Simulation',
          runningSimulation: 'Running Simulation...',
          simulationDescription:
            'Runs hourly energy balance simulation for detailed ventilation analysis',
          simulationInfo:
            'Configure your ventilation units above, then click "Run Simulation" to see detailed hourly energy analysis, savings projections, and ROI timeline.',
          monthChartText: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec',
          ],
          resultLabel: 'Energy Simulation Results',
          annualEnergySavings: 'Annual Energy Savings',
          annualEnergySavingsTooltip:
            'Total energy savings from ventilation improvements',
          annualEnergySavingsUnit: 'kWh/year',
          annualCostSavings: 'Annual Cost Savings',
          annualCostSavingsTooltip:
            'Total cost savings from reduced energy consumption',
          annualCostSavingsUnit: 'NOK/year',
          netCo2Reduction: 'Net CO2 Reduction',
          netCo2ReductionTooltip:
            'Carbon emissions reduction from energy savings',
          netCo2ReductionUnit: 'kg CO₂/year',
          paybackPeriod: 'Payback Period',
          paybackPeriodTooltip:
            'Time to recover the investment cost from savings',
          paybackPeriodUnit: 'years',
          monthlyEnergyConsumption: 'Monthly Energy Consumption',
          kWh: 'kWh',
          paybackPeriodTimeline: 'Return on Investment Timeline',
          years: 'Years',
          NOK: 'NOK',
          cumulativeSavings: 'Cumulative Savings',
          netValue: 'Net Value (after investment)',
          breakEvenPoint:
            'Break-even point occurs when net value crosses zero (year',
          annualEnergyBalanceComparison: 'Annual Energy Balance Comparison',
          category: 'Category',
          beforeKWh: 'Before (kWh)',
          afterKWh: 'After (kWh)',
          savingsKWH: 'Savings (kWh)',
          savings: 'Savings',
          percentChange: '% Change',
          ventilationHeating: 'Ventilation Heating',
          ventilationCooling: 'Ventilation Cooling',
          fanEnergy: 'Fan Energy',
          totalVentilationEnergy: 'Total Ventilation Energy',
          simulationDetails: 'Simulation Details',
          simulationType: 'Simulation Type',
          simulationTypeDescription: '8760-hour physics simulation',
          energyPrice: 'Energy Price',
          energyPriceUnit: 'NOK/kWh',
          simulationDate: 'Simulation Date:',
          building: 'Building',
          co2Factor: 'CO₂ Factor:',
          co2FactorUnit: 'g/kWh',
          before: 'Before',
          transmissionLoss: 'Transmission Loss:',
          ventilationLoss: 'Ventilation Loss:',
          infiltrationLoss: 'Infiltration Loss:',
          solarGains: 'Solar Gains:',
          internalGains: 'Internal Gains:',
          after: 'After',
        },
      },
      led: {
        tiltak: 'LED Actions',
        useableFloorArea: 'Useable Floor Area',
        customValues: 'Custom Values',
        pricePerKwh: 'Price per kWh',
        lightingLoad: 'Lighting Load',
        isCustomTek: 'Enter custom value (TEK = Custom)',
        notCustomTek: 'Calculated from selected TEK; cannot be edited',
        newLightingLoad: 'New Lighting Load (W/m²)',
        investmentCost: 'Investment Cost (kr/m²)',
        operatingHoursPerDay: 'Operating Hours Per Day (hours/day)',
        operatingDaysPerWeek: 'Operating Days Per Week (days/week)',
        operatingWeeksPerYear: 'Operating Weeks Per Year (weeks/year)',
        calculations: 'Calculations',
        standardEnergyNeed: 'Standard Energy Need (kWh)',
        estimatedCostForAction: 'Estimated Cost for Action (NOK)',
        energyNeedBeforeAction: 'Energy Need Before Action',
        estimatedCostBeforeAction: 'Estimated Cost Before Action (NOK)',
        energyNeedAfterAction: 'Energy Need After Action',
        estimatedCostAfterAction: 'Estimated Cost After Action (NOK)',
        savingsAndEconomy: 'Savings and Economy',
        estimatedAnnualSavings: 'Estimated Annual Savings',
        annualSavingsInKWH: 'Annual Savings in kWh',
        annualSavingsInCO2: 'Annual Savings in CO₂ (kg)',
        estimatedTotalCostNOK: 'Estimated Total Cost (NOK)',
        estimatedROI: 'Estimated ROI (%)',
        estimatedPaybackTime: 'Estimated Payback Time (years)',
      },
      heating: {},
      harvesting: {},
      scada: {
        title: 'Control & Regulation',
        contractPeriod: 'Contract Period (years)',
        sastechHourlyFee: 'Sastech Hourly Fee (NOK)',
        markupPercentage: 'Markup Percentage (%)',
        energyPrice: 'Energy Price (NOK)',
        useableHeatedArea: 'Useable Heated Area (m²)',
        energyConsumptionKWH: 'Energy Consumption (kWh)',
        identificationOfSystemType: 'Identification of System Type',
        heatPump: 'Heat Pump',
        ac: 'AC',
        electricBoiler: 'Electric Boiler',
        ventilation: 'Ventilation',
        districtHeating: 'District Heating',
        systemToBeControlled: 'Which system should be controlled?',
        numberOfSystems: 'Number of Systems',
        controllerSelection: 'Controller Selection',
        readWriteAccess:
          'Read/write access via remote access? (District heating only)',
        hasReadRightsDistrictHeating:
          'Are there read rights (district heating only)?',
        communicationOK: 'Communication OK',
        needsInstall: 'Needs to be installed',
        numberOfDampersToControl: 'Number of dampers to control',
        ignitionAzureSupport: 'Ignition, Azure & Support',
        type: 'Type',
        price: 'Price',
        startUp: 'Start-up',
        support: 'Support',
        module: 'Module',
        quantity: 'Quantity',
        total: 'Total',
        gatewayCommunication: 'Gateway Communication',
        localPC: 'Local PC',
        softwarePanelDisplay: 'Software Panel Display',
        supportCommunication: 'Support Communication',
        productConnection: 'Product Connection',
        miscellaneous: 'Miscellaneous',
        extraEnergyMeters: 'Additional energy meters needed',
        electricRadiators: 'Number of electric radiators',
        priceList: {
          title: 'Price List',
          product: 'Product',
          additionalSastechHours: 'Additional Sastech Hours',
          marginNOK: 'Margin NOK',
          marginPercent: 'Margin %',
          buildingCommunication: 'Building Communication',
          localPC: 'Local PC',
          ignitionSupportPercentageOfCost:
            'Ignition support (% share of software cost)',
          electricianIfNoPower: 'Electrician (if no power available)',
          communicationPerProductConnection:
            'Communication per product connection(control)',
          fourGPerContractPeriod: '4G per contract period',
          controller: 'Controller',
          repeater: 'Repeater',
          districtHeatingReading: 'District Heating Reading',
          temperatureSensors: 'Temperature Sensors',
          flowMeters: 'Flow Meters',
          wirelessTransmitter: 'Wireless Transmitter',
          electricianInstallation: 'Electrical installation work',
          sensors: 'Sensors',
          sqmPerSensor: 'sqm per sensor',
          howManySensors: 'Number of sensors in the building',
          gateway: 'Gateway',
          sensorsPerGateway: '- sensors per gateway',
          sensorsPerGatewayDescription:
            'Number of sensors per gateway, but there must be at least one sensor',
          emsWithAspa: 'EMS with ASPA',
          starterPackage: 'Starter Package',
          connectionPerControlUnit: 'Connection per control unit',
          connectionExtraEnergyMeter: 'Connection extra energy meter',
          connectionPerDamper: 'Connection per damper',
          connectionPerPanelHeater: 'Connection per panel heater',
          pipingInstallation: 'Piping Installation',
        },
        products: {
          heatPump: 'Heatpump',
          typePerSystem: 'Type per system',
          fourGPerMonth: '4G per month',
          totalElectricBoiler: 'Total electric boiler',
          ventilation: 'Ventilation',
          districtHeating: 'District Heating',
          pipingInstallation: 'Piping Installation',
          installations: 'Installations',
          electricBoiler: 'Electric Boiler',
        },
        offerSection: {
          title: 'Offer Summary',
          energyManagementSystem: 'Energy Management System',
          automaticSetpointAlgorithm:
            '- including automatic setpoint algorithm',
          extraEnergyMeters: 'Additional energy meters needed',
          pcs: 'pcs',
          panelHeaters: 'Panel heaters',
          overallCommunication: 'Overall communication',
          softwareForCommunication: 'Software for communication',
          supportCommunication: 'Support communication',
          connectionPerControlUnit: 'Connection per control unit',
          priceEstimate: 'Price Estimate',
          estimatedRoi: 'Estimated ROI (years) without possible Enova support',
          years: 'years',
          savingsShareToSastech: 'Savings share to Sastech',
          energyOptimizationSavings: 'Energy optimization savings',
          includedSupportYearly: '* Included support (yearly)',
          sastechHourlyRate: '** Sastech AS hourly rate',
          disclaimer: 'Disclaimer',
          disclaimerPoint1:
            '1. Required access/permissions to the system must be provided by the customer.',
          disclaimerPoint2:
            '2. Network access must be arranged by the customer (firewall / VPN / IP configuration, etc.).',
          disclaimerPoint3: '3. Alarm adjustments will be billed per hour.',
          disclaimerPoint4:
            '4. Setpoint adjustments are carried out and billed hourly.',
          disclaimerPoint5:
            '5. Power supply must be available within 3 meters.',
          disclaimerPoint6:
            '6. For gateway deliveries, it is assumed that the equipment is located in the same room.',
          disclaimerPoint7:
            '7. Controllers required for the heat pump must be provided.',
          disclaimerPoint8:
            '8. Read/write access to the ventilation system must be available.',
        },
      },
      solar: {},
    },
    report: {
      noReportYetTitle: 'No report yet',
      noReportYetDescription:
        'Create your first report draft to get started with documenting the site inspection.',
      noReportYetSubDescription:
        'The report will include chapters, text fields, and attachments organized in a structured format.',
      creatingDraft: 'Creating draft…',
      createDraft: 'Create draft',

      title: 'Report',
      reportGenerationHint1:
        'To generate the report, the site inspection status must be set to completed.',
      reportGenerationHint2: 'Reports are generated every quarter hour.',
      reportGenerationHint3:
        'Data is fetched from the site inspection when the status is set to completed.',

      statusDraft: 'Draft',
      statusAiGenerate: 'AI generation',
      statusComplete: 'Completed',

      reportGenerationTitle: 'Report generation',
      reportGenerationLine1:
        'To generate the report, the site inspection status must be set to completed. Reports are generated every quarter hour.',
      reportGenerationLine2:
        'Data is fetched from the site inspection when the status is set to completed.',

      tableOfContents: 'Table of contents',

      olderVersionWarning:
        'Warning! You are viewing an older version of this report.',

      saving: 'Saving…',
      saveReport: 'Save report',
      deleteReport: 'Delete report',

      confirmDeletionTitle: 'Confirm deletion',
      confirmDeleteReportMessage:
        'Are you sure you want to delete this report?',
      confirmDeleteTextFieldMessage:
        'Are you sure you want to delete this text field?',

      addField: 'Add field',
      fieldSingular: 'field',
      fieldsPlural: 'fields',

      aiPrompt: 'AI prompt',
      reportText: 'Report text',
      attachments: 'Attachments',
      addImage: 'Add image',
      confirmDeleteImage: 'Are you sure you want to delete this image?',

      aiLabel: 'AI',
      scoreLabel: 'Score',

      versionLabel: 'Version',

      exportToWord: 'Export to Word',
      exportingWord: 'Exporting...',
      wordExportProgress: {
        starting: 'Starting export...',
        capturingCharts: 'Capturing charts...',
        capturingDetails: 'Capturing calculation details...',
        buildingDocument: 'Building document...',
        savingFile: 'Saving file...',
        complete: 'Export complete',
        error: 'Export failed. Please try again.',
      },
    },

    UserCalendar: {
      createYourActivity: 'Create your activity',
      categoryErrorMessage: 'Please select a category',
      titleErrorMessage: 'Please enter a title',
      createActivity: 'Create activity',
      editActivity: 'Edit activity',
      confirmDeletion: 'Confirm deletion',
      deleteMessage: 'Are you sure you want to delete this activity?',
    },
  },

  attachments: {
    notes: 'Notes',
    description: 'Description',
    replaceImage: 'Replace Image',
    removeAttachment: 'Remove Attachment',
    tags: 'Tags',
    addImage: 'Add Image',
    uploadImage: 'Upload Screenshot',
  },
  buildingControlProfile: {
    inOperationTitle: 'In operation',
    outsideOperationTitle: 'Outside operation',
    temperatureLower: 'Lower temperature limit',
    temperatureUpper: 'Upper temperature limit',
    humidityLower: 'Lower humidity limit',
    humidityUpper: 'Upper humidity limit',
    co2Tooltip: 'Maximum CO₂ level allowed',
    refreshInterval: 'Refresh interval',
    refreshIntervalHelp: 'How often the ASPA checks these settings.',
    comfortWeight: 'Comfort weight',
    energy: 'Energy',
    comfort: 'Comfort',
    costInfo:
      'The optimizer balances energy use and comfort. A low comfort weight prioritizes low energy use, while a high comfort weight prioritizes better comfort. Both values are calculated on a scale from 0 to 1.',
  },
  gridRegions: {
    label: 'Electricity zone',
    placeholder: '- Select area -',
    groups: {
      nordic: 'Nordic Countries',
      centralEurope: 'Central Europe',
      southernEurope: 'Southern Europe',
      baltic: 'Baltic States',
      britishIsles: 'British Isles',
      easternEurope: 'Eastern Europe',
    },
  },
  addressSearch: {
    label: 'Search by address',
    placeholder: 'Street, number and place',
    moreHint:
      'Showing {shown} of {total}. Add a place or postal code to narrow it down.',
    noHitsHint:
      'No hits. Add the house number and place, for example Storgata 1 Oslo.',
  },
  energyLabelForm: {
    eyebrow: 'Energy certificate',
    language: 'Language',
    themeLight: 'Switch to light theme',
    themeDark: 'Switch to dark theme',
    title: 'Energy label',
    loggedInAs: 'Logged in as',
    logout: 'Log out',
    login: {
      title: 'Log in',
      phoneDescription:
        'Log in with your phone number. A verification code is sent to it by SMS.',
      codeDescription: 'Enter the six-digit code from the SMS.',
      phone: 'Phone number',
      phonePlaceholder: '400 00 000',
      countryCode: 'Country code',
      phoneHint: 'The code is sent to this number.',
      code: 'Verification code',
      codeHint: 'Six digits from the SMS.',
      codeSentTo: 'Code sent to',
      sendCode: 'Send code',
      sendingCode: 'Sending code …',
      verify: 'Verify',
      verifying: 'Logging in …',
      changePhone: 'Use a different phone number',
      resendCode: 'Send a new code',
      codeResent: 'A new code has been sent.',
      errors: {
        invalidPhone: 'Check the phone number and try again.',
        invalidCode: 'The code is not correct. Try again.',
        noCode: 'Ask for a new code.',
        codeExpired: 'The code has expired. Ask for a new code.',
        tooManyAttempts: 'Too many attempts. Ask for a new code.',
        buildingIncomplete:
          'We are missing details about the building to open the form. Please contact us.',
        generic: 'Something went wrong. Try again.',
      },
    },
    flow: {
      navTitle: 'How it works',
      draftSavedAt: 'Your draft — last saved',
      continueLater: 'You can close and continue later.',
      draft: 'Draft',
      saveAndClose: 'Save and close',
      autosaved: 'Your answers are saved automatically.',
      submitted: {
        title: 'Submitted',
        body: 'Thank you. An energy advisor will review your answers.',
      },
      submittedPage: {
        title: 'Thank you! The form is sent in',
        body: 'We have received your answers. There is nothing more you need to do now.',
        building: 'Building',
        sentAt: 'Sent in',
        nextSteps:
          'An energy advisor will review your answers and get in touch if anything is missing.',
        review: 'See your answers',
        logout: 'Log out',
      },
      back: 'Back',
      next: 'Next',
      submit: 'Submit',
      stepsMenu: 'Steps',
      whyWeAsk: 'Why do we ask?',
      validation: {
        range: 'Must be between {min} and {max}.',
        min: 'Must be at least {min}.',
        max: 'Cannot be more than {max}.',
        positive: 'Must be above zero.',
      },
      select: 'Select',
      gnr: 'Gnr',
      bnr: 'bnr',
      buildingNumberShort: 'building no.',
      building: {
        address: 'Address',
        buildingNumber: 'Building no.',
        cadastre: 'Gnr / bnr',
        buildingType: 'Building type',
        usableArea: 'Usable floor area (BRA)',
        footprint: 'Footprint',
      },
      cadastre: {
        notFound:
          'The building was not found in the cadastre. Fill in what you know.',
      },
      yesNo: { yes: 'Yes', no: 'No', dontKnow: "Don't know" },
      status: {
        completed: 'Completed',
        defaults: 'Default values',
        notApplicable: 'Not applicable',
      },
      steps: {
        confirmBuilding: {
          nav: 'Confirm the building',
          title: 'Confirm the building',
          eyebrow: 'Found via GPS and the cadastre',
          question: 'Is this your building?',
          body: 'The building closest to your position is marked. Check that the address and building number are right before you continue.',
          wrongHint:
            'Not right? Tap the correct building on the map, or search by address.',
          searchAddress: 'Search by address',
          mapTitle: 'Building picker',
          noBuilding:
            'No building found here. Drag the marker closer to the building.',
        },
        aboutBuilding: {
          nav: 'About the building',
          title: 'About the building',
          lead: 'Most of this comes from the cadastre. Correct what is wrong — the certificate is built on these numbers.',
          aside: {
            title: 'Category, build year and area',
            body: 'Building category, build year and usable area are the basis for the whole calculation. The category sets the default values, the build year tells which building regulations applied, and the area decides how much energy the building uses per square metre.',
          },
          sections: {
            category: {
              title: 'Building category',
              description:
                'The category decides which default values are used later.',
            },
            area: {
              title: 'Area and height',
              description: 'The footprint can also be read from the map.',
            },
          },
          fields: {
            category: {
              label: 'Category',
              hint: 'Taken from the cadastre when the building is listed there.',
            },
            subcategory: {
              label: 'Subcategory',
              hint: 'Taken from the cadastre when the building is listed there.',
            },
            buildYear: {
              label: 'Year built',
              hint: 'The year construction started, if known.',
            },
            floors: {
              label: 'Number of floors',
              hint: 'Above ground. The basement is added later.',
            },
            footprint: {
              label: 'Footprint',
              hint: 'From the cadastre or the map.',
            },
            usableArea: {
              label: 'Total usable floor area (BRA)',
              hint: 'Total floor area of all storeys, measured inside the exterior walls.',
            },
            heatedArea: {
              label: 'Heated floor area',
              hint: 'The area heated to above 15 °C.',
            },
            floorHeight: {
              label: 'Average floor height',
              hint: 'Leave it empty if you do not know, then the standard value for the category is used.',
            },
          },
          options: {
            categories: {
              kontor: 'Office building',
              lettIndustri: 'Light industry',
              lager: 'Warehouse',
              forretning: 'Retail building',
              skole: 'School building',
              hotell: 'Hotel building',
            },
            subcategories: {
              lettindustriLager: 'Light industry and warehouse',
              verksted: 'Workshop',
              produksjon: 'Production hall',
            },
          },
          knowMore: 'Do you know more about the areas?',
        },
        envelope: {
          nav: 'Building envelope',
          title: 'Building envelope',
          lead: 'How the outer walls are built decides how much heat the building loses. Pick the closest match.',
          sections: {
            walls: {
              title: 'Outer walls',
              description:
                'Material and thickness decide how much heat the walls let out.',
            },
            more: {
              title: 'What else does the building have?',
              description:
                'What you tick here opens its own steps in the menu.',
            },
          },
          fields: {
            construction: {
              label: 'Construction',
              hint: 'The most common type if there are several.',
            },
            insulation: {
              label: 'Insulation thickness',
              hint: 'Leave empty if you do not know — the standard for the build year is used.',
            },
          },
          options: {
            walls: {
              tre: 'Wood',
              mur: 'Masonry',
              staal: 'Steel',
              betong: 'Concrete',
            },
            concrete: { betong10: '10 cm', betong20: '20 cm' },
          },
          checks: {
            basement: { label: 'Basement or lower floor' },
            knowWindows: { label: 'Windows' },
            doors: { label: 'Doors' },
            gates: { label: 'Gates' },
          },
          aside: {
            title: 'Walls and heat loss',
            body: 'A lot of the heat in a building escapes through the walls. The material and insulation tell the advisor how well the building keeps its heat. Pick the closest match and the advisor works out the rest.',
          },
        },
        basement: {
          nav: 'Basement',
          title: 'Basement',
          lead: 'The lower floor is calculated differently because it borders the ground and not the outside air.',
          aside: {
            title: 'Basement against the ground',
            body: 'A basement borders the ground, not the outside air. The ground keeps a steadier temperature through the year, so the heat loss is calculated differently than for walls above ground. Whether the basement is heated decides if it counts towards the heated area. Fill in what you know, empty fields get default values.',
          },
          section: {
            title: 'The lower floor',
            description: 'Only what you know. Empty fields get default values.',
          },
          checks: {
            heated: {
              label: 'The lower floor is heated',
              description:
                'An unheated basement counts as a buffer against the ground.',
            },
          },
          fields: {
            floorArea: { label: 'Basement floor area' },
            wallLength: { label: 'Outer wall length' },
            floorHeight: { label: 'Floor height' },
            wallThickness: { label: 'Basement wall thickness' },
            depth: {
              label: 'Average depth below ground level',
              hint: 'How deep the basement sits in the terrain.',
            },
          },
          knowMore: 'Do you know more about the basement?',
        },
        windows: {
          nav: 'Windows',
          title: 'Windows',
          lead: 'Windows account for much of the heat loss — and the solar gain. The split by orientation matters most.',
          sections: { area: { title: 'The windows of the building' } },
          checks: {
            even: {
              label: 'All windows are evenly spread over the building',
              description: 'The total area is split equally over four facades.',
            },
          },
          fields: {
            windowType: {
              label: 'Window type',
              hint: 'The most common type if there are several.',
            },
            totalArea: {
              label: 'Total window area',
              hint: 'The sum of all window surfaces, measured on the outside of the frame.',
            },
            installYear: {
              label: 'Window installation year',
              hint: 'The year the newest windows were installed.',
            },
            north: { label: 'North' },
            east: { label: 'East' },
            south: { label: 'South' },
            west: { label: 'West' },
          },
          aside: {
            title: 'Orientation',
            body: 'South-facing windows let in the most solar heat and reduce the heating demand. Facing north it is almost only heat loss. That is why we ask per facade.',
          },
          areaSuggestions: {
            typical:
              'Typical for {name}: {heated} of the heated area, {facade} of the facade.',
            under: 'under {value} %',
            noArea:
              'Fill in the heated area under “About the building” and we suggest a window area in m².',
            overTek17:
              'That is {share} % of the heated area. TEK17 allows at most {max} % in new buildings, so check the number once more.',
            profiles: {
              office: {
                name: 'office buildings',
                note: 'Often long window bands. Modern buildings are often close to 25 % of the usable area.',
              },
              school: {
                name: 'schools and universities',
                note: 'The windows are gathered around the classrooms to meet the daylight requirements. Gyms and auditoriums have few windows.',
              },
              kindergarten: {
                name: 'kindergartens',
                note: 'Plenty of daylight in the play rooms, but the windows often sit low to suit children.',
              },
              hotel: {
                name: 'hotels',
                note: 'A fixed amount of glass per hotel room, little glass in corridors and back areas.',
              },
              shop: {
                name: 'shops and commercial buildings',
                note: 'Large display windows at street level, otherwise closed facades.',
              },
              shoppingCentre: {
                name: 'shopping centres',
                note: 'Very closed buildings. The exception is entrances and any glass roofs.',
              },
              culture: {
                name: 'cultural buildings like cinemas and theatres',
                note: 'Large glazed lobbies and foyers, but dark and closed halls.',
              },
              sports: {
                name: 'sports buildings',
                note: 'Few windows in the halls to avoid glare. The windows are mostly in lounges and offices.',
              },
              hospital: {
                name: 'hospitals and nursing homes',
                note: 'Evenly spread over the patient rooms. Hospitals also have large treatment wings without windows.',
              },
              workshop: {
                name: 'workshops and warehouses',
                note: 'Very few windows. The vehicle gates make up most of the openings in the facade.',
              },
            },
          },
          knowMore: 'Do you know how they are split over the facades?',
        },
        doors: {
          nav: 'Doors and gates',
          title: 'Doors and gates',
          lead: 'Doors and gates are part of the building envelope, and the type says a lot about the heat loss. Fill in what you know or remember, the rest gets default values.',
          only: {
            doors: {
              nav: 'Doors',
              title: 'Doors',
              lead: 'The exterior doors are part of the building envelope, and the type says a lot about the heat loss. Fill in what you know or remember, the rest gets default values.',
              aside: {
                title: 'Doors and heat loss',
                body: 'An exterior door lets out more heat than the wall around it. The door type tells the advisor roughly how well it insulates. What you do not know, the advisor works out from the build year and default values.',
              },
            },
            gates: {
              nav: 'Gates',
              title: 'Gates',
              lead: 'Gates are often the largest openings in the building envelope, and the type says a lot about the heat loss. Fill in what you know or remember, the rest gets default values.',
              aside: {
                title: 'Gates and heat loss',
                body: 'Gates are often the largest openings in the building, and they tend to stand open for periods. The gate type tells the advisor roughly how well they insulate. What you do not know, the advisor works out from the build year and default values.',
              },
            },
          },
          aside: {
            title: 'Doors, gates and heat loss',
            body: 'Doors and gates let out more heat than the wall around them, and gates tend to stand open for periods. The type tells the advisor roughly how well they insulate. What you do not know, the advisor works out from the build year and default values.',
          },
          sections: {
            doors: {
              title: 'Doors',
              description: 'Exterior doors for people.',
            },
            gates: {
              title: 'Gates',
              description: 'Vehicle gates, loading doors and similar.',
            },
          },
          fields: {
            doorType: {
              label: 'Door type',
              hint: 'The most common type if there are several.',
            },
            installYear: { label: 'Installation year' },
            uValue: {
              label: 'U-value, average',
              hint: 'Leave empty if you do not know.',
            },
            gateType: {
              label: 'Gate type',
              hint: 'The most common type if there are several.',
            },
            area: { label: 'Area' },
          },
          options: {
            doorTypes: {
              isolertStaal: 'Steel door',
              glass: 'Glass door',
              tre: 'Wooden door',
              aluminium: 'Aluminium door',
            },
            gateTypes: {
              leddportIsolert: 'Insulated sectional door',
              leddport: 'Uninsulated sectional door',
              rulleport: 'Roller door',
              hurtigport: 'High-speed door',
            },
          },
          knowMoreDoors: 'Do you know more about the doors?',
          knowMoreGates: 'Do you know more about the gates?',
        },
        energySources: {
          nav: 'Energy sources',
          title: 'Energy sources',
          lead: 'Which energy sources does the building have? The choices here open the next steps.',
          sections: {
            delivered: {
              title: 'Delivered energy',
              description: 'Tick everything connected to the building.',
            },
            own: { title: 'Own production' },
          },
          checks: {
            electricity: {
              label: 'Electricity',
              description:
                'All buildings have electricity. Electricity only gives a simplified calculation.',
            },
            districtHeating: {
              label: 'District heating',
              description: 'Opens the step Central heating system.',
            },
            heatPump: {
              label: 'Heat pump',
              description: 'Opens the Heat pump step.',
            },
            fossil: {
              label: 'Oil, gas or bio',
              description: 'Opens the step Boiler.',
            },
            other: {
              label: 'Other energy sources',
              description: 'Describe in the comment field in the last step.',
            },
            solar: {
              label: 'The building has solar panels',
              description: 'Opens the Solar panels step.',
            },
          },
          aside: {
            title: 'Central heating',
            body: 'District heating, heat pumps and boilers can all be connected to one central heating system. The next step asks how they share heating and hot water.',
          },
        },
        centralHeating: {
          nav: 'Central heating system',
          title: 'Central heating system',
          lead: 'Selected energy sources — this is how they are set up in the central heating system.',
          sections: {
            plant: { title: 'The system' },
            districtHeating: {
              title: 'District heating',
              description: 'How the district heating is used in the building.',
            },
          },
          fields: {
            location: { label: 'Location', hint: 'Where the plant room is.' },
            installYear: { label: 'Installation year' },
            connectedTo: {
              label: 'Connected to',
              hint: 'Where the water goes.',
            },
          },
          options: {
            locations: {
              tekniskRom: 'Plant room',
              kjeller: 'Basement',
              tak: 'Roof',
              egetBygg: 'Separate building',
            },
            connections: {
              oppvarming: 'Heating',
              oppvarmingVent: 'Heating and ventilation',
            },
          },
          checks: {
            forHeating: { label: 'Space heating' },
            forHotWater: { label: 'Domestic hot water' },
          },
          aside: {
            title: 'Heat is distributed from the plant',
            body: 'The central heating system carries heat from the energy sources into the building as water. Where the plant stands, and whether the water also heats the ventilation air, decides how much heat is lost on the way. If you lack the details, we use default values.',
          },
        },
        heatPump: {
          nav: 'Heat pump',
          title: 'Heat pump',
          lead: 'Type and performance of the heat pump. Output and consumption are usually on the rating plate or in the service booklet.',
          sections: {
            plant: { title: 'The system' },
            connection: { title: 'Connection' },
          },
          fields: {
            type: { label: 'Type' },
            installYear: { label: 'Installation year' },
            power: {
              label: 'Output',
              hint: 'Nominal heating output from the rating plate.',
            },
            annualUse: {
              label: 'Annual consumption',
              hint: 'From the electricity meter or control system, if available.',
            },
          },
          options: {
            types: {
              luftLuft: 'Air-to-air',
              luftVann: 'Air-to-water',
              vaeskeVann: 'Liquid–water',
              avtrekk: 'Exhaust air heat pump',
            },
          },
          checks: {
            connected: {
              label: 'The heat pump is connected to the central heating system',
              description: 'The share is set in the Heating and cooling step.',
            },
          },
          knowMore: 'Do you know more about the heat pump?',
          aside: {
            title: 'More heat than electricity',
            body: 'A heat pump draws heat from the air, water or ground and delivers more kilowatt hours of heat than it uses in electricity. Type, output and age decide how efficient it is, and that goes straight into the energy label. If you lack the numbers, we use default values.',
          },
        },
        boiler: {
          nav: 'Boiler',
          title: 'Boiler',
          lead: 'The boiler fired with oil, gas or biomass. The output is usually on the rating plate.',
          sections: { plant: { title: 'The boiler' } },
          fields: {
            fuelType: { label: 'Boiler type' },
            power: {
              label: 'Output at full load',
              hint: 'From the rating plate or the documentation.',
            },
          },
          options: {
            fuelTypes: { olje: 'Oil', gass: 'Gas', bio: 'Biomass' },
          },
          aside: {
            title: 'Fuel counts differently',
            body: 'Oil, gas and biomass are weighted differently in the energy certificate, so the boiler type affects both the energy label and the heating grade. The output tells us how much of the heating demand the boiler can cover. If you lack the numbers, we use default values.',
          },
        },
        solar: {
          nav: 'Solar panels',
          title: 'Solar panels',
          lead: 'Self-produced electricity is deducted from delivered energy in the certificate.',
          sections: {
            plant: {
              title: 'The solar installation',
              description:
                'The numbers are usually in the documentation from the installer or in the app for the system.',
            },
            hotWater: { title: 'Hot water' },
          },
          fields: {
            installedPower: {
              label: 'Installed capacity',
              hint: 'Found in the installation documentation.',
            },
            installYear: { label: 'Installation year' },
            annualProduction: {
              label: 'Annual production',
              hint: 'From the inverter or the app for the system.',
            },
            panelArea: { label: 'Panel area' },
          },
          checks: {
            hotWaterConnected: {
              label: 'Hot water is connected to the central system',
              description:
                'See energy sources. Otherwise hot water counts as electric.',
            },
          },
          aside: {
            title: 'Your own power counts',
            body: 'The power from the solar panels covers part of what the building uses, and that can give a better energy label. That is why we need to know the size of the system. If you lack the numbers, say so in the comment field in the last step.',
          },
          knowMore: 'Do you know more about the solar plant?',
        },
        ventilation: {
          nav: 'Ventilation',
          systemTitle: 'System {number}',
          title: 'Ventilation',
          lead: 'Does the building have a ventilation system?',
          sections: {
            type: {
              title: 'Ventilation system',
              description: 'Only balanced ventilation needs more details.',
            },
            plant: {
              title: 'The system',
              description:
                'A unit blows fresh air in and pulls used air out, often with heat recovery.',
            },
            capacity: {
              title: 'Capacity — per system',
              description:
                'If the capacity exceeds the minimum, it must be stated.',
            },
            maintenance: { title: 'Maintenance' },
          },
          fields: {
            hasSystems: {
              label: 'Does the building have a ventilation system?',
            },
            count: {
              label: 'Number of systems',
              hint: 'You get one set of fields per system.',
            },
            type: { label: 'Type' },
            installYear: { label: 'Installation year' },
            airflowOperating: { label: 'Airflow during operating hours' },
            airflowOff: { label: 'Airflow outside operating hours' },
            lastMaintenance: {
              label: 'Last maintenance date',
              hint: 'From the service report.',
            },
            regularMaintenance: { label: 'Regular maintenance of the system?' },
            moreInfo: {
              label: 'Anything more for the advisor about the ventilation?',
              hint: 'Filter changes, operating hours, known deviations.',
            },
            heatRecovery: {
              label: 'Heat recovery efficiency',
              hint: 'From the unit documentation.',
            },
          },
          checks: {
            exhaustHeatPump: {
              label: 'Exhaust air heat pump connected to the central system',
            },
            extractHeatPump: {
              label: 'Extract air heat pump connected to the central system',
            },
          },
          options: {
            types: {
              avtrekk: 'Mechanical extract',
              balansert: 'Balanced ventilation',
            },
            typeDescriptions: {
              avtrekk: 'Large parts of the building have mechanical extract.',
            },
          },
          aside: {
            title: 'Air and heat',
            body: 'Ventilation replaces used indoor air with fresh outdoor air. A system that recovers heat from the air going out saves a lot of energy. If you lack the numbers, we use default values.',
          },
          knowMore: 'Do you know more about the ventilation?',
        },
        heating: {
          nav: 'Heating and cooling',
          title: 'Heating and cooling',
          lead: 'The suggestions below are based on the energy sources and ventilation you chose. Fill in the share each solution covers, if you know it.',
          groups: {
            electric: { title: 'Electric heating' },
            central: { title: 'Central heating' },
          },
          options: {
            electric: {
              panelHeaters: 'Panel heaters',
              convectors: 'Convectors',
              electricBoiler: 'Electric boiler with hot water tank',
              electricFloor: 'Underfloor heating',
              ventilationHeat: 'Ventilation heating',
              airToAir: 'Air-to-air heat pump',
            },
            central: {
              radiators: 'Radiators',
              convectors: 'Convectors',
              waterFloor: 'Underfloor heating',
              ventilationHeat: 'Ventilation heating',
            },
          },
          sections: { cooling: { title: 'Cooling' } },
          checks: {
            hasCooling: {
              label: 'The building has cooling',
              description:
                'Chiller, district cooling or heat pump in cooling mode.',
            },
          },
          aside: {
            title: 'Fill in what you know',
            body: 'If you don’t know, you don’t need to fill in the fields. Fill in what you know, know something about, or approximate values. More detail gives the energy advisor a better basis.',
          },
          singleShare: 'We assume this one covers all the heating.',
        },
        summary: {
          nav: 'Summary and submission',
          title: 'Summary and submission',
          lead: 'The energy certificate gets more accurate — and often better — when more fields are filled in.',
          alert: {
            title: '{count} steps use default values',
            body: 'With incomplete data the energy labelling is carried out on limited information. Parts of the technical systems and the building are then calculated with default values. You can submit now, or go back and fill in more for a more accurate label.',
          },
          registered: 'What you have registered',
          confirmFirst:
            'Confirm that the information is given in good faith before you submit.',
          sections: { advisor: { title: 'For the advisor' } },
          fields: {
            note: {
              label:
                'Anything the advisor should know about energy flow and consumption?',
              hint: 'For example: parts of the building stand empty, night and weekend setback, recent replacements, known leaks.',
            },
          },
          checks: {
            goodFaith: {
              label:
                'All information is registered to the best of my understanding and in good faith',
              description:
                'The advisor uses your answers as the basis for the energy certificate. You can correct things later if something was wrong.',
            },
          },
          aside: {
            eyebrow: 'What happens now?',
            title: 'Your registration goes to the advisor',
            body: 'An energy advisor checks your answers and sends the energy certificate to Enova. Nobody needs to visit the building. You are notified when the certificate is ready.',
          },
        },
      },
      knowInstallYear: 'Do you know the installation year?',
      assumeBuildYear: 'We assume it is from {year}.',
      buildYearWord: 'the build year',
      assumeStandard: 'We assume standard values.',
    },
  },
};

export default ENGLISH;
